$wj([46],{

/***/ 1709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var composeStore_1 = __webpack_require__(158);
var owa_mail_feature_flags_1 = __webpack_require__(23);
exports.default = {
    MailComposeNew: {
        datapoint: {
            name: 'MailComposeNew',
            options: { isQos: true },
            customData: function (actionSource) { return [
                actionSource,
                !owa_mail_feature_flags_1.isMailFeatureEnabled('rp-tabView') && !!composeStore_1.getStore().defaultViewState,
            ]; },
        },
    },
    MailComposeFromHeader: { datapoint: { name: 'MailComposeFromHeader' } },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 1721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ToggleFavoriteButton_1 = __webpack_require__(2330);
exports.ToggleFavoriteButton = ToggleFavoriteButton_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config = {};
function initializePersona(inputConfig) {
    config = inputConfig;
}
exports.initializePersona = initializePersona;
function getConfig() {
    return config;
}
exports.getConfig = getConfig;
//# sourceMappingURL=personaConfig.js.map

/***/ }),

/***/ 1848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var folderIdToName_1 = __webpack_require__(48);
exports.default = {
    selectFilter: {
        datapoint: {
            name: 'TnS_SelectFilter',
            options: { enablePerformanceMarks: true },
            customData: function (viewFilter, actionSource) { return [
                viewFilter,
                actionSource,
            ]; },
        },
    },
    selectSort: {
        datapoint: {
            name: 'TnS_MailListSelectSort',
            customData: function (sortColumn, sortDirection, tableView, actionSource) { return [
                sortColumn,
                sortDirection,
                actionSource,
                tableView.totalRowsInView,
                folderIdToName_1.default(tableView.tableQuery.folderId),
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 2077:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var clearFilter_1 = __webpack_require__(2323);
exports.clearFilter = clearFilter_1.default;
var datapoints_1 = __webpack_require__(1848);
exports.datapoints = datapoints_1.default;
var selectFilter_1 = __webpack_require__(2078);
exports.selectFilter = selectFilter_1.default;
var selectSort_1 = __webpack_require__(2324);
exports.selectSort = selectSort_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(1848);
var owa_mail_list_actions_1 = __webpack_require__(80);
var owa_mail_list_store_1 = __webpack_require__(5);
var getSelectedTableView_1 = __webpack_require__(46);
var owa_mail_table_loading_actions_1 = __webpack_require__(63);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
/**
 * Selects a filter on a current selected table view
 * @param viewFilter viewFilter to select
 * @param actionSource source of this action
 */
exports.default = legacy_1.action('selectFilter', datapoints_1.default.selectFilter)(function selectFilter(viewFilter, actionSource) {
    var selectedTableView = getSelectedTableView_1.default();
    if (viewFilter == 'UserCategory') {
        throw new Error('ViewFilter should not be user category when select filter is called');
    }
    var tableQuery = owa_mail_list_actions_1.createMailFolderTableQuery(selectedTableView.tableQuery.folderId, selectedTableView.tableQuery.listViewType, owa_mail_list_store_1.getFocusedFilterForTable(selectedTableView), viewFilter, null /* categoryName */, // Cateogries and view filters ['All', 'Unread', 'To Me', 'Flagged'] cannot exist together as when a category folder is selected. The view filter needs to be set to UserCategory
    owa_mail_list_store_1.getSortByForTable(selectedTableView) // Retain the sort column when selecting filter
    );
    undoActions.clearLastUndoableAction();
    return owa_mail_table_loading_actions_1.loadTableViewFromTableQuery(tableQuery, null /* startLoadTableViewDatapoint */, actionSource);
});
//# sourceMappingURL=selectFilter.js.map

/***/ }),

/***/ 2079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var mailListFilterViewStoreData = {
    filterContextMenuDisplayState: false,
};
exports.getStore = satcheljs_1.createStore('mailListFilterView', mailListFilterViewStoreData);
exports.store = exports.getStore();
//# sourceMappingURL=Store.js.map

/***/ }),

/***/ 2267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = __webpack_require__(22);
var owa_assert_1 = __webpack_require__(123);
function getViewFilterDisplay(filter) {
    switch (filter) {
        case 'All':
            return owa_mail_strings_1.default.allFilter;
        case 'Unread':
            return owa_mail_strings_1.default.unreadFilter;
        case 'Flagged':
            return owa_mail_strings_1.default.flaggedFilter;
        case 'ToOrCcMe':
            return owa_mail_strings_1.default.toMeFilter;
        case 'HasAttachment':
        case 'TaskActive':
        case 'TaskOverdue':
        case 'TaskCompleted':
        case 'DeprecatedSuggestions':
        case 'DeprecatedSuggestionsRespond':
        case 'DeprecatedSuggestionsDelete':
        case 'DeprecatedNoClutter':
        case 'DeprecatedClutter':
        case 'SystemCategory':
        case 'UserCategory':
        case 'Pinned':
        case 'Focused':
        case 'Locked':
        case 'Mentioned':
        case 'Hashtag':
            throw new Error('Filter not implemented');
        default:
            return owa_assert_1.assertNever(filter);
    }
}
exports.default = getViewFilterDisplay;
//# sourceMappingURL=getViewFilterDisplay.js.map

/***/ }),

/***/ 2322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getViewFilterDisplay_1 = __webpack_require__(2267);
var Icon_1 = __webpack_require__(43);
var mobx_react_1 = __webpack_require__(11);
var owa_mail_filter_actions_1 = __webpack_require__(2077);
var owa_mail_focus_manager_1 = __webpack_require__(208);
var KeyboardCharCodes_1 = __webpack_require__(634);
var owa_mail_list_filter_view_1 = __webpack_require__(2325);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var owa_mail_list_filter_store_1 = __webpack_require__(2326);
var owa_accessibility_1 = __webpack_require__(79);
var classNames = __webpack_require__(30);
var styles = __webpack_require__(2328);
var MailListFilter = /** @class */ (function (_super) {
    tslib_1.__extends(MailListFilter, _super);
    function MailListFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.onFilterClick = function (evt) {
            evt.stopPropagation();
            _this.onSelectFilter();
        };
        /**
         * Called when user presses keyboard on the filter dropdown title in listview
         */
        _this.onKeyDownOnFilter = function (ev) {
            switch (ev.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                case KeyboardCharCodes_1.SPACE_CHARCODE:
                    ev.stopPropagation();
                    ev.preventDefault();
                    _this.onSelectFilter();
                    break;
            }
        };
        return _this;
    }
    MailListFilter.prototype.onSelectFilter = function () {
        if (owa_mail_list_store_1.getViewFilterForTable(owa_mail_list_store_1.getSelectedTableView()) == 'All') {
            owa_mail_list_filter_store_1.showFilterDropDownContextMenu();
        }
        else {
            // Dismiss the filter if the LV is already filtered
            owa_mail_filter_actions_1.selectFilter('All', this.props.filterMenuSource);
            // Reset focus when the filter is closing and changing to "All"
            owa_mail_focus_manager_1.resetFocus();
        }
    };
    MailListFilter.prototype.dismissContextMenu = function () {
        owa_mail_list_filter_store_1.hideFilterDropDownContextMenu();
        // Reset focus when filter context menu is dismissed
        owa_mail_focus_manager_1.resetFocus();
    };
    MailListFilter.prototype.getSelectedFilterText = function (currentSelectedFilter) {
        if (currentSelectedFilter == 'All') {
            return owa_mail_strings_1.default.mailFilter;
        }
        return getViewFilterDisplay_1.default(currentSelectedFilter);
    };
    MailListFilter.prototype.render = function () {
        var _this = this;
        var currentSelectedFilter = owa_mail_list_store_1.getViewFilterForTable(owa_mail_list_store_1.listViewStore.tableViews.get(this.props.tableViewId));
        var isAllFilterSelected = currentSelectedFilter == 'All';
        var containerClassNames = classNames(this.props.containerClassName, styles.filter);
        var dropDownIconClassNames = classNames(styles.icon, !isAllFilterSelected && styles.cancelIcon);
        var ariaProps = {
            role: owa_accessibility_1.AriaRoles.button,
        };
        return (React.createElement("div", tslib_1.__assign({ ref: function (ref) { return (_this.container = ref); }, className: containerClassNames, onClick: this.onFilterClick, onKeyDown: this.onKeyDownOnFilter }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps), { tabIndex: 0 }),
            React.createElement("span", { className: styles.filterText }, this.getSelectedFilterText(currentSelectedFilter)),
            React.createElement(Icon_1.Icon, { className: dropDownIconClassNames, iconName: isAllFilterSelected ? "ChevronDownMed" /* ChevronDownMed */ : "Cancel" /* Cancel */ }),
            owa_mail_list_filter_store_1.filterViewStore.filterContextMenuDisplayState && (React.createElement(owa_mail_list_filter_view_1.MailFilterContextMenu, { currentViewFilter: currentSelectedFilter, supportedViewFilters: this.props.supportedViewFilters, dismissContextMenu: this.dismissContextMenu, contextMenuTargetElement: this.container, filterMenuSource: this.props.filterMenuSource, tableViewId: this.props.tableViewId }))));
    };
    MailListFilter = tslib_1.__decorate([
        mobx_react_1.observer
    ], MailListFilter);
    return MailListFilter;
}(React.Component));
exports.default = MailListFilter;
//# sourceMappingURL=MailListFilter.js.map

/***/ }),

/***/ 2323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var selectFilter_1 = __webpack_require__(2078);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('clearFilter')(function clearFilter(actionSource) {
    selectFilter_1.default('All', actionSource);
});
//# sourceMappingURL=clearFilter.js.map

/***/ }),

/***/ 2324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(1848);
var owa_mail_list_actions_1 = __webpack_require__(80);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_table_loading_actions_1 = __webpack_require__(63);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
var selectSortInternal = legacy_1.action('selectSortInternal', datapoints_1.default.selectSort)(function selectSortInternal(sortColumnToSelect, sortDirectionToSelect, tableView, actionSource) {
    var sortBy = {
        sortColumn: sortColumnToSelect,
        sortDirection: sortDirectionToSelect,
    };
    var tableQuery = owa_mail_list_actions_1.createMailFolderTableQuery(tableView.tableQuery.folderId, tableView.tableQuery.listViewType, owa_mail_list_store_1.getFocusedFilterForTable(tableView), 'All', null /* categoryName */, // Support sort - VSO: 23489 - Category Filter Drop down menu to show in category list view and category search
    sortBy // sortBy selected by the user
    );
    return owa_mail_table_loading_actions_1.loadTableViewFromTableQuery(tableQuery);
});
/**
 * Selects the sort on the current selected table
 * @param sortColumn selected by the user
 * @param tableViewId table view id
 * @param actionSource source of this action
 */
exports.default = legacy_1.action('selectSort')(function selectSort(sortColumn, tableViewId, actionSource) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var currentSortBy = tableView.tableQuery.sortBy;
    var isSameSortColumnSelected = currentSortBy.sortColumn == sortColumn;
    var sortDirectionToSelect;
    if (isSameSortColumnSelected) {
        // If same sort is selected then toggle the sort direction and load the table
        sortDirectionToSelect =
            currentSortBy.sortDirection == owa_mail_list_store_1.MailSortHelper.ASCENDING_SORT_DIR
                ? owa_mail_list_store_1.MailSortHelper.DESCENDING_SORT_DIR
                : owa_mail_list_store_1.MailSortHelper.ASCENDING_SORT_DIR;
    }
    else {
        // If different sort is selected then get the default sort direction for this sort column
        sortDirectionToSelect = owa_mail_list_store_1.MailSortHelper.getDefaulSortDirectionForSortColumn(sortColumn);
    }
    selectSortInternal(sortColumn, sortDirectionToSelect, tableView, actionSource);
    undoActions.clearLastUndoableAction();
});
//# sourceMappingURL=selectSort.js.map

/***/ }),

/***/ 2325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 2576));
});
// Delay loaded components
exports.MailFilterContextMenu = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.MailFilterContextMenu; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var filterContextMenuAction_1 = __webpack_require__(2327);
exports.hideFilterDropDownContextMenu = filterContextMenuAction_1.hideFilterDropDownContextMenu;
exports.showFilterDropDownContextMenu = filterContextMenuAction_1.showFilterDropDownContextMenu;
var Store_1 = __webpack_require__(2079);
exports.filterViewStore = Store_1.store;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var Store_1 = __webpack_require__(2079);
exports.showFilterDropDownContextMenu = legacy_1.action('showFilterDropDownContextMenu')(function () {
    Store_1.getStore().filterContextMenuDisplayState = true;
});
exports.hideFilterDropDownContextMenu = legacy_1.action('hideFilterDropDownContextMenu')(function () {
    Store_1.getStore().filterContextMenuDisplayState = false;
});
//# sourceMappingURL=filterContextMenuAction.js.map

/***/ }),

/***/ 2328:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2329);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2329:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".QAS4pFKCqswPU5fpvcIOX{cursor:pointer;font-size:14px;font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";font-weight:600;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] .QAS4pFKCqswPU5fpvcIOX{padding-top:2px}._1Q6qmbDfVktTkuve0L8XsX{font-weight:400;font-size:10px;color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._1Q6qmbDfVktTkuve0L8XsX{padding-left:4px}html[dir=rtl] ._1Q6qmbDfVktTkuve0L8XsX{padding-right:4px}", ""]);

// exports
exports.locals = {
	"filter": "QAS4pFKCqswPU5fpvcIOX",
	"icon": "_1Q6qmbDfVktTkuve0L8XsX"
};

/***/ }),

/***/ 2330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_accessibility_1 = __webpack_require__(79);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var Button_1 = __webpack_require__(62);
var Spinner_1 = __webpack_require__(670);
var styles = __webpack_require__(2331);
var classNames = __webpack_require__(30).bind(styles);
var SPINNER_TIMEOUT = 2000; //ms
var spinnerTimer = null;
var ToggleFavoriteButton = /** @class */ (function (_super) {
    tslib_1.__extends(ToggleFavoriteButton, _super);
    function ToggleFavoriteButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSpinner: false,
        };
        return _this;
    }
    // We want to show the spinner only 2 seconds after the favorite action if clickDisabled is still true
    ToggleFavoriteButton.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (!this.props.isClickDisabled && nextProps.isClickDisabled) {
            spinnerTimer = setTimeout(function () {
                _this.setState({
                    showSpinner: true,
                });
            }, SPINNER_TIMEOUT);
        }
        if (this.props.isClickDisabled && !nextProps.isClickDisabled) {
            if (this.state.showSpinner) {
                this.setState({
                    showSpinner: false,
                });
            }
            if (spinnerTimer) {
                clearTimeout(spinnerTimer);
                spinnerTimer = null;
            }
        }
    };
    ToggleFavoriteButton.prototype.componentWillUnmount = function () {
        if (spinnerTimer) {
            clearTimeout(spinnerTimer);
            spinnerTimer = null;
        }
    };
    ToggleFavoriteButton.prototype.render = function () {
        var _this = this;
        var favoriteIcon = this.props.isInFavorites
            ? "FavoriteStarFill" /* FavoriteStarFill */
            : "FavoriteStar" /* FavoriteStar */;
        var favoriteIconClassNames = classNames(this.props.className ? this.props.className : styles.favoriteIcon, styles.favoriteIconBase, this.props.animate && this.props.isInFavorites ? styles.saved : undefined);
        var tooltip = this.props.isInFavorites
            ? owa_mail_strings_1.default.removeFromFavoritesText
            : owa_mail_strings_1.default.addToFavoritesText;
        var shouldHideFromAccessibilityTree = this.props.isWrappedInAnotherButton;
        var ariaProps = shouldHideFromAccessibilityTree
            ? {
                role: owa_accessibility_1.AriaRoles.presentation,
                hidden: true,
            }
            : {
                role: undefined,
                label: owa_mail_strings_1.default.favoriteCharmAriaLabelText,
                pressed: this.props.isInFavorites,
            };
        var buttonClassNames = classNames(styles.container, this.props.isClickDisabled && styles.clickDisabled);
        return this.state.showSpinner && this.props.isClickDisabled ? (React.createElement("div", tslib_1.__assign({ className: styles.spinnerContainer, tabIndex: shouldHideFromAccessibilityTree ? -1 : undefined, title: tooltip }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)),
            React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small }),
            React.createElement("div", { className: styles.spinnerText }, this.props.text))) : (React.createElement(Button_1.ActionButton, tslib_1.__assign({ className: buttonClassNames, onClick: function (event) { return !_this.props.isClickDisabled && _this.props.onClick(event); }, tabIndex: shouldHideFromAccessibilityTree ? -1 : undefined, iconProps: {
                iconName: favoriteIcon,
                styles: {
                    root: favoriteIconClassNames,
                },
            }, text: this.props.text, title: tooltip, styles: this.props.styles }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps))));
    };
    ToggleFavoriteButton = tslib_1.__decorate([
        mobx_react_1.observer
    ], ToggleFavoriteButton);
    return ToggleFavoriteButton;
}(React.Component));
exports.default = ToggleFavoriteButton;
//# sourceMappingURL=ToggleFavoriteButton.js.map

/***/ }),

/***/ 2331:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2332);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2332:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".fzm4_kevVwNsuPYfUvOfV{cursor:pointer}html[dir] .fzm4_kevVwNsuPYfUvOfV{background:none}._1xsSfKzBsNdEbV0SSl9YnG{font-size:15px}._332urtrlRUwgsL7v-XxTNS{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:28px}html[dir=ltr] ._332urtrlRUwgsL7v-XxTNS{padding-left:5px}html[dir=rtl] ._332urtrlRUwgsL7v-XxTNS{padding-right:5px}._2EaDDJs2xpVhEu_SU7kzi3{line-height:100%}html[dir=ltr] ._2EaDDJs2xpVhEu_SU7kzi3,html[dir=rtl] ._2EaDDJs2xpVhEu_SU7kzi3{margin-left:4px;margin-right:4px}.x2R9jLL7nAuLN0KA2NTAo{cursor:default}._3no19If9dzOlhEiBREpRrv:before,.x2R9jLL7nAuLN0KA2NTAo,.x2R9jLL7nAuLN0KA2NTAo:hover:before{color:\"[theme:themeDark, default:#0D62AA]\"}._3no19If9dzOlhEiBREpRrv:hover:before{color:\"[theme:themeDarker, default:#004578]\"}._3no19If9dzOlhEiBREpRrv:active:before{color:\"[theme:themeDark, default:#0D62AA]\"}._3no19If9dzOlhEiBREpRrv:after{content:\"\";position:absolute;z-index:0;top:6px;bottom:0;opacity:1;overflow:visible;width:15px;height:15px}html[dir] ._3no19If9dzOlhEiBREpRrv:after{background:\"[theme:themeDarker, default:#004578]\";border-radius:50%;-webkit-transform:scale(0);transform:scale(0)}html[dir=ltr] ._3no19If9dzOlhEiBREpRrv:after{left:0;right:0;margin-left:4px}html[dir=rtl] ._3no19If9dzOlhEiBREpRrv:after{right:0;left:0;margin-right:4px}._3no19If9dzOlhEiBREpRrv._1ujZdxWaHLT9mtj5Ul0C9h:after{opacity:0}html[dir] ._3no19If9dzOlhEiBREpRrv._1ujZdxWaHLT9mtj5Ul0C9h:after{-webkit-transform:scale(1.4);transform:scale(1.4);-webkit-transition:opacity .6s ease-out,-webkit-transform .6s ease-out;transition:opacity .6s ease-out,-webkit-transform .6s ease-out;transition:transform .6s ease-out,opacity .6s ease-out;transition:transform .6s ease-out,opacity .6s ease-out,-webkit-transform .6s ease-out}", ""]);

// exports
exports.locals = {
	"container": "fzm4_kevVwNsuPYfUvOfV",
	"favoriteIcon": "_1xsSfKzBsNdEbV0SSl9YnG",
	"spinnerContainer": "_332urtrlRUwgsL7v-XxTNS",
	"spinnerText": "_2EaDDJs2xpVhEu_SU7kzi3",
	"clickDisabled": "x2R9jLL7nAuLN0KA2NTAo",
	"favoriteIconBase": "_3no19If9dzOlhEiBREpRrv",
	"saved": "_1ujZdxWaHLT9mtj5Ul0C9h"
};

/***/ }),

/***/ 2342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PersonaHeader_1 = __webpack_require__(5973);
exports.PersonaHeader = PersonaHeader_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_guid_1 = __webpack_require__(585);
exports.isInitialized = false;
exports.clientCorrelationId = undefined;
exports.clientType = undefined;
exports.clientScenario = undefined;
exports.culture = undefined;
exports.isConsumer = false;
exports.useDogfood = false;
exports.isMicrosoftUser = false;
var logger = undefined;
var MicrosoftTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47';
var MicrosoftExoTenantId = '626bd560-f1d8-4cf1-a7fa-91aae03cc409';
function initializeLoki(config) {
    if (exports.isInitialized) {
        throw new Error('initializeLoki can be called only once!');
    }
    if (!config) {
        throw new Error('Loki config object is mandatory!');
    }
    exports.clientType = 'OwaMail';
    exports.clientScenario = config.isConsumer ? 'OwaConsumer' : 'OwaEnterprise';
    exports.culture = config.culture;
    exports.isConsumer = config.isConsumer;
    exports.useDogfood = config.useDogfood;
    logger = config.logger;
    var tenantId = config.tenantId && config.tenantId.toLowerCase();
    exports.isMicrosoftUser = tenantId === MicrosoftTenantId || tenantId === MicrosoftExoTenantId;
    exports.clientCorrelationId = config.clientCorrelationId || owa_guid_1.getGuid();
    exports.isInitialized = true;
}
exports.initializeLoki = initializeLoki;
function log(logType, logResultType, message) {
    logger(logType, [logResultType, message]);
}
exports.log = log;
//# sourceMappingURL=lokiContext.js.map

/***/ }),

/***/ 2620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialRecipientCacheStore = {
    recipientCache: null,
};
var store = satcheljs_1.createStore('recipientcache', initialRecipientCacheStore)();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isLokiEndpoint_1 = __webpack_require__(2716);
exports.isLokiEndpoint = isLokiEndpoint_1.isLokiEndpoint;
var Base64 = __webpack_require__(2717);
exports.Base64 = Base64;
var Functional = __webpack_require__(2718);
exports.Functional = Functional;
var StorageUtils = __webpack_require__(2719);
exports.StorageUtils = StorageUtils;
var StringUtils = __webpack_require__(2648);
exports.StringUtils = StringUtils;
var UrlUtils_1 = __webpack_require__(2722);
exports.getUrlParameter = UrlUtils_1.getUrlParameter;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isNullOrWhiteSpace_1 = __webpack_require__(2676);
exports.isNullOrWhiteSpace = isNullOrWhiteSpace_1.isNullOrWhiteSpace;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLokiBootstrapperConfig_1 = __webpack_require__(2645);
exports.getLokiBootstrapperConfig = getLokiBootstrapperConfig_1.getLokiBootstrapperConfig;
var userInfoProvider_1 = __webpack_require__(2725);
exports.getUserInfo = userInfoProvider_1.getUserInfo;
var lokiContext_1 = __webpack_require__(2612);
exports.lokiClientCorrelationId = lokiContext_1.clientCorrelationId;
exports.initializeLoki = lokiContext_1.initializeLoki;
var live_persona_card_bootstrapper_1 = __webpack_require__(2650);
exports.initializeLivePersonaCard = live_persona_card_bootstrapper_1.initializeLivePersonaCard;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var requestAuthTokenHandler_1 = __webpack_require__(2646);
var lokiContext = __webpack_require__(2612);
function getLokiBootstrapperConfig() {
    if (!lokiContext.isInitialized) {
        throw new Error('You must call initializeLoki!');
    }
    var config = {
        culture: lokiContext.culture,
        region: getLokiRegion(lokiContext.useDogfood, lokiContext.isMicrosoftUser),
        clientType: lokiContext.clientType,
        clientContextType: lokiContext.clientScenario,
        clientCorrelationId: lokiContext.clientCorrelationId,
        logMessage: function (logType, logResultType, message) {
            lokiContext.log(logType, logResultType, message);
        },
        getAuthToken: requestAuthTokenHandler_1.refreshAuthToken,
        authToken: requestAuthTokenHandler_1.latestAuthToken,
    };
    return config;
}
exports.getLokiBootstrapperConfig = getLokiBootstrapperConfig;
function getLokiRegion(useLokiDogfood, isMicrosoftUser) {
    if (useLokiDogfood) {
        return 'df';
    }
    if (isMicrosoftUser) {
        return 'msit';
    }
    return '';
}
//# sourceMappingURL=getLokiBootstrapperConfig.js.map

/***/ }),

/***/ 2646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loki_auth_token_1 = __webpack_require__(2715);
var lokiContext_1 = __webpack_require__(2612);
var getLokiAuthTokenAsync_1 = __webpack_require__(2724);
var authTokenProvider = undefined;
exports.latestAuthToken = undefined;
function getAuthToken() {
    if (!authTokenProvider) {
        authTokenProvider = new loki_auth_token_1.AuthTokenProvider(function () { return lokiContext_1.clientCorrelationId; }, getRefreshAuthToken(), null, null);
    }
    return authTokenProvider.getAuthToken();
}
exports.getAuthToken = getAuthToken;
function refreshAuthToken(onSuccess, onFailure) {
    getLokiAuthTokenAsync_1.default().then(function (token) {
        var authTokenRequestCorrelationId = lokiContext_1.clientCorrelationId;
        if (token) {
            setAuthToken(token);
            onSuccess(token, authTokenRequestCorrelationId);
        }
        else {
            onFailure('Failed to get auth token from Loki', authTokenRequestCorrelationId);
        }
    });
}
exports.refreshAuthToken = refreshAuthToken;
function setAuthToken(newAuthToken) {
    exports.latestAuthToken = newAuthToken;
    loki_auth_token_1.setAuthToken(lokiContext_1.clientCorrelationId, newAuthToken);
}
function getRefreshAuthToken() {
    return function (callback) {
        refreshAuthToken(function (authToken, authRequestCorrelationId) {
            callback(authToken, '', authRequestCorrelationId);
        }, function (errorMessage, authRequestCorrelationId) {
            callback('', errorMessage, authRequestCorrelationId);
        });
    };
}
//# sourceMappingURL=requestAuthTokenHandler.js.map

/***/ }),

/***/ 2647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lpc_utils_1 = __webpack_require__(2622);
var lpc_utils_2 = __webpack_require__(2622);
var AUTH_TOKEN_PARSE_ERROR = "AuthTokenParseError";
var DEFAULT_GET_AUTH_TOKEN_TIMEOUT = 10000; /* 10s */
var TOKEN_LIFETIME_BUFFER = 5 * 60 * 1000; /* 5m */
var GET_AUTH_TOKEN_TIMEOUT = "GetAuthTokenTimeout";
var CACHED_TOKEN_EXPIRED = "CachedTokenExpired";
var AUTH_TOKEN_PARTS = 3;
var INVALID_TOKEN_EXPIRATION = "InvalidTokenExpirationValue";
var AuthToken = (function () {
    function AuthToken(value, scopeName, logger) {
        this.value = value;
        this.scopeName = scopeName;
        this.logger = logger;
    }
    AuthToken.prototype.isValid = function () {
        if (!this.value) {
            return false;
        }
        var expiryTime = this.extractAuthTokenExpiration();
        if (expiryTime <= 0) {
            if (this.logger) {
                this.logger.logError(INVALID_TOKEN_EXPIRATION, this.scopeName, { expiryTime: expiryTime.toString() });
            }
            return false;
        }
        // Date.now() returns milliseconds while expiryTime in authToken uses seconds
        if (Date.now() > expiryTime * 1000 - TOKEN_LIFETIME_BUFFER) {
            if (this.logger) {
                this.logger.logEvent(CACHED_TOKEN_EXPIRED, this.scopeName);
            }
            return false;
        }
        return true;
    };
    AuthToken.prototype.getValue = function () {
        return this.value;
    };
    AuthToken.prototype.refresh = function (refreshAuthTokenCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var timeoutId = window.setTimeout(function () {
                // Don't introduce PII as we are logging the rejection scenarios
                reject(GET_AUTH_TOKEN_TIMEOUT);
            }, DEFAULT_GET_AUTH_TOKEN_TIMEOUT);
            refreshAuthTokenCallback(function (token, error, authRequestCorrelationId) {
                window.clearTimeout(timeoutId);
                if (lpc_utils_1.StringUtils.isNullOrEmpty(error)) {
                    _this.value = token;
                    resolve(_this);
                }
                else {
                    // Don't introduce PII as we are logging the rejection scenarios
                    reject("Couldn't retrieve token! authRequestCorrelationId: " + authRequestCorrelationId);
                }
            });
        });
    };
    AuthToken.prototype.getLoggableProps = function () {
        // Expiry time is in seconds in the auth token, so convert to milliseconds:
        var expiryTime = this.extractAuthTokenExpiration() * 1000;
        return { expirationTime: expiryTime, expiresIn: expiryTime - Date.now() };
    };
    AuthToken.prototype.getLoggablePropsAsString = function () {
        return JSON.stringify(this.getLoggableProps());
    };
    AuthToken.prototype.getTokenLifetimeBuffer = function () {
        return TOKEN_LIFETIME_BUFFER;
    };
    // Extract the object id from the auth token
    AuthToken.prototype.extractAuthTokenOid = function () {
        /* tslint:disable:no-any */
        var payload = this.extractPayload();
        /* tslint:enable:no-any */
        if (payload) {
            return payload.oid;
        }
        return "";
    };
    AuthToken.prototype.extractAuthTokenExpiration = function () {
        /* tslint:disable:no-any */
        var payload = this.extractPayload();
        /* tslint:enable:no-any */
        if (payload) {
            return payload.exp;
        }
        return 0;
    };
    /* tslint:disable:no-any */
    AuthToken.prototype.extractPayload = function () {
        /* tslint:enable:no-any */
        if (!this.value) {
            return null;
        }
        var tokenParts = this.value.split(".");
        if (tokenParts.length !== AUTH_TOKEN_PARTS) {
            if (this.logger) {
                this.logger.logError(AUTH_TOKEN_PARSE_ERROR, this.scopeName, { partsCount: tokenParts.length.toString() });
            }
            return null;
        }
        try {
            /* tslint:disable:no-any */
            var payload = JSON.parse(lpc_utils_2.Base64.decode(tokenParts[1]));
            /* tslint:enable:no-any */
            return payload;
        }
        catch (ex) {
            if (this.logger) {
                this.logger.logError(AUTH_TOKEN_PARSE_ERROR, this.scopeName, { error: ex });
            }
            return null;
        }
    };
    return AuthToken;
}());
exports.AuthToken = AuthToken;
//# sourceMappingURL=authToken.js.map

/***/ }),

/***/ 2648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var emptyString = "";
var guidEmpty = "00000000-0000-0000-0000-000000000000";
var guidFormatString = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
function isNullOrEmpty(str) {
    return str === null || str === undefined || str === emptyString;
}
exports.isNullOrEmpty = isNullOrEmpty;
function isNullOrWhitespace(str) {
    return str === null || str === undefined || str.trim() === emptyString;
}
exports.isNullOrWhitespace = isNullOrWhitespace;
function isGuidNullOrEmpty(guid) {
    return isNullOrEmpty(guid) || guid === guidEmpty;
}
exports.isGuidNullOrEmpty = isGuidNullOrEmpty;
// Ranges from isCJK method found numerous places in msasg code.
// This one breaks on Android, and has therefore been replaced by the other one by this tool:
// https://mothereff.in/regexpu
// const cjkRegExp = /[\u{3400}-\u{9fff}\u{f900}-\u{faff}\u{20000}-\u{2a6df}\u{2f800}-\u{2fa1f}]/u;
var cjkRegExp = /(?:[\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]|\uD87E[\uDC00-\uDE1F])/;
function isCJK(text) {
    return cjkRegExp.test(text);
}
exports.isCJK = isCJK;
function generateGuid() {
    /* Equivalent of var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); */
    return guidFormatString.replace(/[xy]/g, function (c) {
        var r;
        if (window.crypto) {
            var array = new Uint8Array(1);
            window.crypto.getRandomValues(array);
            r = array[0];
        }
        else {
            r = Math.floor(Math.random() * 16);
        }
        var v = c === "x" ? r % 16 : r % 4 + 8;
        return v.toString(16);
    });
}
exports.generateGuid = generateGuid;
/* Ex: { param1: val1, param2: val2 } => "param1=val1,param2=val2" */
function createCommaDelimitedParamStringFromObject(data) {
    // IE does not support data.constructor.name (https://stackoverflow.com/questions/25140723/constructor-name-is-undefined-in-internet-explorer)
    if (Object.prototype.toString.call(data) !== "[object Object]") {
        throw new TypeError("Param data must be a valid object");
    }
    var values = [];
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        values.push(key + "=" + data[key]);
    }
    return values.join(",");
}
exports.createCommaDelimitedParamStringFromObject = createCommaDelimitedParamStringFromObject;
function format(str) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!str) {
        return emptyString;
    }
    if (args != null && args.length > 0) {
        for (var i = 0; i < args.length; i++) {
            var val = args[i];
            var replString = val === null || val === undefined ? emptyString : val.toString();
            var matchPattern = new RegExp("\\{" + i + "\\}", "g");
            str = str.replace(matchPattern, replString);
        }
    }
    return str;
}
exports.format = format;
function toUTF8(s) {
    if (unescape && encodeURIComponent) {
        return unescape(encodeURIComponent(s));
    }
    else {
        return s;
    }
}
exports.toUTF8 = toUTF8;
function fromUTF8(s) {
    if (decodeURIComponent && escape) {
        return decodeURIComponent(escape(s));
    }
    else {
        return s;
    }
}
exports.fromUTF8 = fromUTF8;
//# sourceMappingURL=StringUtils.js.map

/***/ }),

/***/ 2649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lpc_utils_1 = __webpack_require__(2622);
var getItem = lpc_utils_1.StorageUtils.getItem, setItem = lpc_utils_1.StorageUtils.setItem, removeItem = lpc_utils_1.StorageUtils.removeItem;
var AUTH_TOKEN_STORAGE_KEY = "LokiAuthToken";
function setAuthTokenOnUrl(url, authToken) {
    if (authToken && lpc_utils_1.isLokiEndpoint(url)) {
        var queryStringOperator = url.indexOf("?") > -1 ? "&" : "?";
        return "" + url + queryStringOperator + "AuthToken=" + authToken;
    }
    return url;
}
exports.setAuthTokenOnUrl = setAuthTokenOnUrl;
function getAuthToken(appId) {
    return getItem(AUTH_TOKEN_STORAGE_KEY, appId || "") || "";
}
exports.getAuthToken = getAuthToken;
function setAuthToken(appId, authToken) {
    if (authToken) {
        setItem(AUTH_TOKEN_STORAGE_KEY, authToken, appId || "");
    }
}
exports.setAuthToken = setAuthToken;
function clearAuthToken(appId) {
    removeItem(AUTH_TOKEN_STORAGE_KEY, appId || "");
}
exports.clearAuthToken = clearAuthToken;
function removeAuthTokenFromUrl(url) {
    if (url) {
        return url.replace(/AuthToken=[\w-.]*[&$]?/, "");
    }
    return url;
}
exports.removeAuthTokenFromUrl = removeAuthTokenFromUrl;
//# sourceMappingURL=authUtils.js.map

/***/ }),

/***/ 2650:
/***/ (function(module, exports, __webpack_require__) {

/*! Version: 1.3.14; Third Party Notices: https://go.microsoft.com/fwlink/?linkid=855968 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("LivePersonaCardBootstrapper",[],e):"object"==typeof exports?exports.LivePersonaCardBootstrapper=e():t.LivePersonaCardBootstrapper=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=36)}([function(t,e,n){"use strict";n.d(e,"a",function(){return i});var i=function(){function t(t,e,n){this.type=t,this.message=e,this.rootCorrelationId=n}return t}()},function(t,e,n){"use strict";var i=function(){function t(t){this.low=0,this.high=0,this.low=parseInt(t,10),this.low<0&&(this.high=-1)}return t.prototype.Equals=function(e){var n=new t(e);return this.low===n.low&&this.high===n.high},t}();e.Int64=i;var r=function(){function t(t){this.low=0,this.high=0,this.low=parseInt(t,10)}return t.prototype.Equals=function(e){var n=new t(e);return this.low===n.low&&this.high===n.high},t}();e.UInt64=r;var o=function(){function t(){}return t.ToByte=function(t){return this.ToUInt8(t)},t.ToInt16=function(t){return 32767&t|(32768&t)<<16>>16},t.ToInt32=function(t){return 2147483647&t|2147483648&t},t.ToUInt8=function(t){return 255&t},t.ToUInt32=function(t){return 4294967295&t},t}();e.Number=o},function(t,e,n){"use strict";!function(t){t[t.NotSet=0]="NotSet",t[t.DistinguishedName=1]="DistinguishedName",t[t.GenericData=2]="GenericData",t[t.IPV4Address=3]="IPV4Address",t[t.IPv6Address=4]="IPv6Address",t[t.MailSubject=5]="MailSubject",t[t.PhoneNumber=6]="PhoneNumber",t[t.QueryString=7]="QueryString",t[t.SipAddress=8]="SipAddress",t[t.SmtpAddress=9]="SmtpAddress",t[t.Identity=10]="Identity",t[t.Uri=11]="Uri",t[t.Fqdn=12]="Fqdn",t[t.IPV4AddressLegacy=13]="IPV4AddressLegacy"}(e.AWTPiiKind||(e.AWTPiiKind={}))},function(t,e,n){"use strict";var i=n(12),r=n(2),o=n(4),s=function(){function t(){}return t.getPayloadBlob=function(t,e){var n=new i.IO.MemoryStream,r=new i.CompactBinaryProtocolWriter(n);return r.WriteFieldBegin(i.BondDataType.BT_MAP,3),r.WriteMapContainerBegin(e,i.BondDataType.BT_STRING,i.BondDataType.BT_LIST),Object.keys(t).forEach(function(e){r.WriteString(e);var n=t[e];r.WriteContainerBegin(1,i.BondDataType.BT_STRUCT),r.WriteFieldBegin(i.BondDataType.BT_STRING,2),r.WriteString("act_default_source"),r.WriteFieldBegin(i.BondDataType.BT_STRING,5),r.WriteString(o.newGuid()),r.WriteFieldBegin(i.BondDataType.BT_INT64,6),r.WriteInt64(o.numberToBondInt64(Date.now())),r.WriteFieldBegin(i.BondDataType.BT_LIST,8),r.WriteContainerBegin(n.length,i.BondDataType.BT_STRUCT);for(var s=0;s<n.length;++s)r.WriteBlob(n[s]);r.WriteStructEnd(!1)}),r.WriteStructEnd(!1),n.GetBuffer()},t.getEventBlob=function(t){var e=new i.IO.MemoryStream,n=new i.CompactBinaryProtocolWriter(e);n.WriteFieldBegin(i.BondDataType.BT_STRING,1),n.WriteString(t.id),n.WriteFieldBegin(i.BondDataType.BT_INT64,3),n.WriteInt64(o.numberToBondInt64(t.timestamp)),n.WriteFieldBegin(i.BondDataType.BT_STRING,5),n.WriteString(t.type),n.WriteFieldBegin(i.BondDataType.BT_STRING,6),n.WriteString(t.name);var s=[],u=[];return Object.keys(t.properties).forEach(function(e){t.properties[e].pii===r.AWTPiiKind.NotSet?s.push(e):u.push(e)}),s.length&&(n.WriteFieldBegin(i.BondDataType.BT_MAP,13),n.WriteMapContainerBegin(s.length,i.BondDataType.BT_STRING,i.BondDataType.BT_STRING),s.forEach(function(e){n.WriteString(e),n.WriteString(t.properties[e].value)})),u.length&&(n.WriteFieldBegin(i.BondDataType.BT_MAP,30),n.WriteMapContainerBegin(u.length,i.BondDataType.BT_STRING,i.BondDataType.BT_STRUCT),u.forEach(function(e){n.WriteString(e),n.WriteFieldBegin(i.BondDataType.BT_INT32,1),n.WriteInt32(1),n.WriteFieldBegin(i.BondDataType.BT_INT32,2),n.WriteInt32(t.properties[e].pii),n.WriteFieldBegin(i.BondDataType.BT_STRING,3),n.WriteString(t.properties[e].value),n.WriteStructEnd(!1)})),n.WriteStructEnd(!1),e.GetBuffer()},t.base64Encode=function(t){return i.Encoding.Base64.GetString(t)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=s},function(t,e,n){"use strict";function i(t){var e=new s.Int64("0");return e.low=4294967295&t,e.high=Math.floor(t/4294967296),e}function r(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(u,function(t){var e=16*Math.random()|0;return("x"===t?e:3&e|8).toString(16)})}function o(t){return!isNaN(t)&&null!==t&&t>=0&&t<=13}var s=n(1),u=/[xy]/g;e.numberToBondInt64=i,e.newGuid=r,e.isPii=o},function(t,e,n){"use strict";var i=n(2);e.AWTPiiKind=i.AWTPiiKind;var r=n(16);e.AWT=r.default,e.AWT_COLLECTOR_URL_UNITED_STATES="https://us.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_GERMANY="https://de.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_JAPAN="https://jp.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_AUSTRALIA="https://au.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_EUROPE="https://eu.pipe.aria.microsoft.com/Collector/3.0/"},function(t,e,n){"use strict";e.Version="1.2.0",e.FullVersionString="AWT-Web-CJS-"+e.Version},function(t,e,n){"use strict";function i(t){t=t.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var e=new RegExp("[\\?&]"+t+"=([^&#]*)"),n=e.exec(location.search);return null===n?"":decodeURIComponent(n[1].replace(/\+/g," "))}e.a=i},function(t,e,n){"use strict";function i(t,e,i){return v=v||new Promise(function(r,a){try{var g,v,y=new p.a;o(t),n.i(h.a)(t).then(function(){return n.i(l.a)(t)}).then(function(e){return y.measureFromStart(p.b.getAuthToken),v=n.i(l.b)(e),t.tenantAadObjectId=v.tenantId,t.userAadObjectId=v.userAadId,t.userPuid=v.userPuid,n.i(c.a)(e,t)}).then(function(t){return y.measureFromStart(p.b.getLokiConfig),g=t,_.AWT.setContext("LokiUrl",t.LokiUrl),_.AWT.setContext("tenantAadObjectId",v.tenantId),_.AWT.setContext("userAadObjectId",v.userAadId),_.AWT.setContext("userPuid",v.userPuid),n.i(d.a)(g)}).then(function(){return y.measureFromStart(p.b.getLpcBundles),n.i(f.a)(g,t,y)}).then(function(){var t=s(y.getAllTimings());t.RootCorrelationId=g.RootCorrelationId,_.AWT.logEvent({name:"initializeLivePersonaCard_success",properties:t}),u(),e&&e(),r()}).catch(function(t){var e=s(y.getAllTimings());t.type&&(e.ErrorType=t.type),t.message&&(e.ErrorMessage=t.message),t.rootCorrelationId&&(e.RootCorrelationId=t.rootCorrelationId),navigator&&void 0!==typeof navigator.onLine&&(e.IsClientOnline=navigator.onLine),e.IsCatastrophic=!1,_.AWT.logEvent({name:"initializeLivePersonaCard_failure",properties:e}),u(),i&&i("Failed to initialize Live Persona Card: "+t.type),a("Failed to initialize Live Persona Card: "+t.type)})}catch(t){try{_.AWT.logEvent({name:"initializeLivePersonaCard_failure",properties:{IsCatastrophic:!0,Reason:t.toString()},tenantToken:T}),u()}catch(t){console.error("Couldn't log error through ARIA: "+t.toString())}i&&i("Failed to initialize Live Persona Card: "+t.name+" "+t.message),a("Failed to initialize Live Persona Card: "+t.name+" "+t.message)}})}function r(t){return n.i(l.a)(t).then(function(e){return n.i(c.a)(e,t)})}function o(t){_.AWT.initialize(T),_.AWT.setContext("culture",t.culture),_.AWT.setContext("region",t.region),_.AWT.setContext("clientType",t.clientType),_.AWT.setContext("clientContextType",t.clientContextType),_.AWT.setContext("clientCorrelationId",t.clientCorrelationId),_.AWT.setContext("bootstrapperVersion",g)}function s(t){var e={};return Object.keys(t).forEach(function(n){e["Perf_"+n]=t[n].toString()}),e}function u(){_.AWT.flush(function(){})}Object.defineProperty(e,"__esModule",{value:!0}),e.initializeLivePersonaCard=i,e.fetchLokiConfig=r;var a=n(18),c=(n.n(a),n(24)),l=n(23),f=n(26),d=n(25),h=n(32),p=n(29),_=n(5),g=(n.n(_),n(34));n.i(a.polyfill)();var v,T="e5ad760145754ffc9704e67c800087f2-dc72ff20-3e8a-401a-b9a8-ec72e4dd3e22-7257"},function(t,e,n){"use strict";!function(t){t[t.BT_STOP=0]="BT_STOP",t[t.BT_STOP_BASE=1]="BT_STOP_BASE",t[t.BT_UINT8=3]="BT_UINT8",t[t.BT_UINT32=5]="BT_UINT32",t[t.BT_UINT64=6]="BT_UINT64",t[t.BT_STRING=9]="BT_STRING",t[t.BT_STRUCT=10]="BT_STRUCT",t[t.BT_LIST=11]="BT_LIST",t[t.BT_MAP=13]="BT_MAP",t[t.BT_INT32=16]="BT_INT32",t[t.BT_INT64=17]="BT_INT64",t[t.BT_UNAVAILABLE=127]="BT_UNAVAILABLE"}(e.BondDataType||(e.BondDataType={}))},function(t,e,n){"use strict";var i=n(1),r=function(){function t(){}return t.GetBytes=function(t){for(var e=[],n=0;n<t.length;++n){var i=t.charCodeAt(n);i<128?e.push(i):i<2048?e.push(192|i>>6,128|63&i):i<55296||i>=57344?e.push(224|i>>12,128|i>>6&63,128|63&i):(i=65536+((1023&i)<<10|1023&t.charCodeAt(++n)),e.push(240|i>>18,128|i>>12&63,128|i>>6&63,128|63&i))}return e},t}();e.Utf8=r;var o=function(){function t(){}return t.GetString=function(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n=[],i=t.length%3,r=0,o=t.length-i;r<o;r+=3){var s=(t[r]<<16)+(t[r+1]<<8)+t[r+2];n.push(function(t){return[e.charAt(t>>18&63),e.charAt(t>>12&63),e.charAt(t>>6&63),e.charAt(63&t)].join("")}(s))}switch(i){case 1:var s=t[t.length-1];n.push(e.charAt(s>>2)),n.push(e.charAt(s<<4&63)),n.push("==");break;case 2:var u=(t[t.length-2]<<8)+t[t.length-1];n.push(e.charAt(u>>10)),n.push(e.charAt(u>>4&63)),n.push(e.charAt(u<<2&63)),n.push("=")}return n.join("")},t}();e.Base64=o;var s=function(){function t(){}return t.GetBytes=function(t){for(var e=[];4294967168&t;)e.push(127&t|128),t>>>=7;return e.push(127&t),e},t}();e.Varint=s;var u=function(){function t(){}return t.GetBytes=function(t){for(var e=t.low,n=t.high,i=[];n||4294967168&e;)i.push(127&e|128),e=(127&n)<<25|e>>>7,n>>>=7;return i.push(127&e),i},t}();e.Varint64=u;var a=function(){function t(){}return t.EncodeZigzag32=function(t){return(t=i.Number.ToInt32(t))<<1^t>>31},t.EncodeZigzag64=function(t){var e=t.low,n=t.high,r=n<<1|e>>>31,o=e<<1;2147483648&n&&(r=~r,o=~o);var s=new i.UInt64("0");return s.low=o,s.high=r,s},t}();e.Zigzag=a},function(t,e,n){"use strict";var i=n(1),r=function(){function t(){this._buffer=[]}return t.prototype.WriteByte=function(t){this._buffer.push(i.Number.ToByte(t))},t.prototype.Write=function(t,e,n){for(;n--;)this.WriteByte(t[e++])},t.prototype.GetBuffer=function(){return this._buffer},t}();e.MemoryStream=r},function(t,e,n){"use strict";var i=n(9);e.BondDataType=i.BondDataType;var r=n(10);e.Encoding=r;var o=n(11);e.IO=o;var s=n(1);e.Int64=s.Int64,e.UInt64=s.UInt64,e.Number=s.Number;var u=function(){function t(t){this._stream=t}return t.prototype.WriteBlob=function(t){this._stream.Write(t,0,t.length)},t.prototype.WriteContainerBegin=function(t,e){this.WriteUInt8(e),this.WriteUInt32(t)},t.prototype.WriteMapContainerBegin=function(t,e,n){this.WriteUInt8(e),this.WriteUInt8(n),this.WriteUInt32(t)},t.prototype.WriteFieldBegin=function(t,e){e<=5?this._stream.WriteByte(t|e<<5):e<=255?(this._stream.WriteByte(192|t),this._stream.WriteByte(e)):(this._stream.WriteByte(224|t),this._stream.WriteByte(e),this._stream.WriteByte(e>>8))},t.prototype.WriteInt32=function(t){t=r.Zigzag.EncodeZigzag32(t),this.WriteUInt32(t)},t.prototype.WriteInt64=function(t){this.WriteUInt64(r.Zigzag.EncodeZigzag64(t))},t.prototype.WriteString=function(t){if(""===t)this.WriteUInt32(0);else{var e=r.Utf8.GetBytes(t);this.WriteUInt32(e.length),this._stream.Write(e,0,e.length)}},t.prototype.WriteStructEnd=function(t){this.WriteUInt8(t?i.BondDataType.BT_STOP_BASE:i.BondDataType.BT_STOP)},t.prototype.WriteUInt32=function(t){var e=r.Varint.GetBytes(s.Number.ToUInt32(t));this._stream.Write(e,0,e.length)},t.prototype.WriteUInt64=function(t){var e=r.Varint64.GetBytes(t);this._stream.Write(e,0,e.length)},t.prototype.WriteUInt8=function(t){this._stream.WriteByte(s.Number.ToUInt8(t))},t}();e.CompactBinaryProtocolWriter=u},function(t,e,n){"use strict";var i=function(){function t(){this._killedTokenDictionary={}}return t.prototype.setKillSwitchTenants=function(t,e){var n=this;if(t&&e)try{var i=t.split(",");if("this-request-only"===e)return i;var r=1e3*parseInt(e,10);i.forEach(function(t){n._killedTokenDictionary[t]=Date.now()+r})}catch(t){return[]}return[]},t.prototype.isTenantKilled=function(t){return void 0!==this._killedTokenDictionary[t]&&this._killedTokenDictionary[t]>Date.now()||(delete this._killedTokenDictionary[t],!1)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=i},function(t,e,n){"use strict";var i=n(3),r=function(){function t(t,e){this._maxRequestSize=t,this._outboundQueue=e,this._currentBatch={},this._currentBatchSize=0}return t.prototype.addEventToBatch=function(t){var e=i.default.getEventBlob(t);e.length>this._maxRequestSize||(this._currentBatchSize+e.length>this._maxRequestSize?this.flushBatch():(void 0===this._currentBatch[t.tenantToken]&&(this._currentBatch[t.tenantToken]=[]),this._currentBatch[t.tenantToken].push(e),this._currentBatchSize+=e.length))},t.prototype.flushBatch=function(){this._currentBatchSize>0&&(this._outboundQueue.push(this._currentBatch),this._currentBatch={},this._currentBatchSize=0)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=r},function(t,e,n){"use strict";var i=function(){function t(){}return t.shouldRetryForStatus=function(t){return!(t>=300&&t<500&&408!==t||501===t||505===t)},t.getMillisToBackoffForRetry=function(t){var e=0,n=Math.floor(1200*Math.random())+2400;return e=Math.pow(4,t)*n,Math.min(e,12e4)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=i},function(t,e,n){"use strict";var i=n(2),r=n(17),o=n(4),s=n(6),u=/^[a-zA-Z0-9]([a-zA-Z0-9]|_){2,98}[a-zA-Z0-9]$/,a=/\./g,c=/^[a-zA-Z0-9](([a-zA-Z0-9|_|\.]){0,98}[a-zA-Z0-9])?$/,l=function(){function t(){}return t.initialize=function(t,e){if(void 0===e&&(e={}),this._isInitialized)throw"Already Initialized";this._defaultTenantToken=t,this._overrideValuesFromConfig(e),r.default.initialize(this._config),this._isInitialized=!0},t.flush=function(t){this._isInitialized&&!this._isDestroyed&&r.default.flush(t)},t.flushAndTeardown=function(){this._isInitialized&&!this._isDestroyed&&(this._isDestroyed=!0,r.default.flushAndTeardown())},t.setContext=function(t,e,n){void 0===n&&(n="allTkns"),null!==(e=this._sanitizeProperty(t,e))&&(this._contextProperties[n]||(this._contextProperties[n]={}),this._contextProperties[n][t]=e)},t.logEvent=function(t){var e=this;if(this._isInitialized){if(!t.name||!t.properties)return;t.name=t.name.toLowerCase(),t.name.replace(a,"_");var n="";if(t.type?(t.type.toLowerCase(),n="custom."):t.type="custom",!u.test(t.name)||!u.test(t.type))return;if(t.type=n+t.type,isNaN(t.timestamp)&&(t.timestamp=(new Date).getTime()),t.tenantToken||(t.tenantToken=this._defaultTenantToken),t.id=o.newGuid(),Object.keys(t.properties).forEach(function(n){t.properties[n]=e._sanitizeProperty(n,t.properties[n]),null===t.properties[n]&&delete t.properties[n]}),this._addContextIfAbsent(t,t.tenantToken),this._addContextIfAbsent(t,"allTkns"),0===Object.keys(t.properties).length)return;this._setDefaultProperty(t,"EventInfo.InitId",this._getInitId(t.tenantToken)),this._setDefaultProperty(t,"EventInfo.Sequence",this._getSequenceId(t.tenantToken)),this._setDefaultProperty(t,"EventInfo.SdkVersion",s.FullVersionString),this._setDefaultProperty(t,"EventInfo.Name",t.name),this._setDefaultProperty(t,"EventInfo.Time",new Date(t.timestamp).toISOString()),r.default.sendEvent(t)}},t._overrideValuesFromConfig=function(t){t.collectorUrl&&(this._config.collectorUrl=t.collectorUrl),t.sendingTimer>1e3&&(this._config.sendingTimer=t.sendingTimer)},t._getInitId=function(t){return void 0===this._initIdMap[t]&&(this._initIdMap[t]=o.newGuid()),this._initIdMap[t]},t._getSequenceId=function(t){return void 0===this._sequenceIdMap[t]&&(this._sequenceIdMap[t]=0),(++this._sequenceIdMap[t]).toString()},t._setDefaultProperty=function(t,e,n){t.properties[e]={value:n,pii:i.AWTPiiKind.NotSet}},t._addContextIfAbsent=function(t,e){if(this._contextProperties[e]){var n=this._contextProperties[e];Object.keys(n).forEach(function(e){t.properties[e]||(t.properties[e]=n[e])})}},t._sanitizeProperty=function(t,e){return"string"!=typeof e&&"number"!=typeof e&&"boolean"!=typeof e||(e={value:e}),c.test(t)&&void 0!==e&&null!==e&&null!==e.value&&void 0!==e.value&&""!==e.value?(void 0===e.pii&&(e.pii=i.AWTPiiKind.NotSet),e.value=e.value.toString(),o.isPii(e.pii)?e:null):null},t}();l._isInitialized=!1,l._isDestroyed=!1,l._contextProperties={},l._sequenceIdMap={},l._initIdMap={},l._config={collectorUrl:"https://browser.pipe.aria.microsoft.com/Collector/3.0/",sendingTimer:1e3},Object.defineProperty(e,"__esModule",{value:!0}),e.default=l},function(t,e,n){"use strict";var i=n(14),r=n(3),o=n(15),s=n(13),u=n(6),a=function(){function t(){}return t.initialize=function(t){this._inboundQueues.push([]),this._recordBatcher=new i.default(2936012,this._outboundQueue),this._newEventsAllowed=!0,"undefined"==typeof Uint8Array&&(this._urlString+="&content-encoding=base64"),this._sendingTimer=t.sendingTimer,this._urlString=t.collectorUrl+this._urlString+"&x-apikey="},t.sendEvent=function(t){var e=this;this._newEventsAllowed&&(this._inboundQueues[this._inboundQueues.length-1].push(t),!this._running&&this._timeout<0&&!this._isCurrentlyFlushing&&(this._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},this._sendingTimer)))},t.flushAndTeardown=function(){this._newEventsAllowed=!1,this._batchAndSendEvents(!0)},t.flush=function(t){this._inboundQueues.push([]),this._isCurrentlyFlushing?this._flushQueue.push(t):(this._isCurrentlyFlushing=!0,this._flush(t))},t._batchAndSendEvents=function(t){for(this._running=!0;this._inboundQueues[0].length>0&&this._outboundQueue.length<1;)this._recordBatcher.addEventToBatch(this._inboundQueues[0].pop());0===this._outboundQueue.length&&this._recordBatcher.flushBatch(),this._sendRequest(this._outboundQueue.pop(),0,t)},t._retryRequestIfNeeded=function(t,e,n,i,r){var s=this,u=!0;if(t&&void 0!==t.status){this._killSwitch.setKillSwitchTenants(t.getResponseHeader("kill-tokens"),t.getResponseHeader("kill-duration-seconds")).forEach(function(t){delete e[t],n--}),(!o.default.shouldRetryForStatus(t.status)||n<=0)&&(u=!1)}u&&r<4?setTimeout(function(){return s._sendRequest(e,r+1,!1)},o.default.getMillisToBackoffForRetry(r)):this._handleRequestFinished(null)},t._sendRequest=function(t,e,n){var i=this,o=new XMLHttpRequest,s=0,u="";if(Object.keys(t).forEach(function(e){i._killSwitch.isTenantKilled(e)?delete t[e]:(u.length>0&&(u+=","),u+=e,s++)}),o.open("POST",this._urlString+u,!n),n||(o.ontimeout=function(){i._retryRequestIfNeeded(o,t,s,u,e)},o.onerror=function(){i._retryRequestIfNeeded(o,t,s,u,e)},o.onload=function(){i._handleRequestFinished(o)}),s>0){var a=r.default.getPayloadBlob(t,s);"undefined"==typeof Uint8Array?o.send(r.default.base64Encode(a)):o.send(new Uint8Array(a))}else n&&this._handleRequestFinished(null)},t._handleRequestFinished=function(t){var e=this;t&&this._killSwitch.setKillSwitchTenants(t.getResponseHeader("kill-tokens"),t.getResponseHeader("kill-duration-seconds")),this._inboundQueues[0].length>0?this._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},this._sendingTimer):(this._timeout=-1,this._running=!1)},t._flush=function(t){var e=this;this._running||(this._timeout>-1&&(clearTimeout(this._timeout),this._timeout=-1),this._inboundQueues[0].length>0&&this._batchAndSendEvents(!1)),this._checkPrimaryInboundQueueEmpty(function(){e._inboundQueues.shift(),null!==t&&void 0!==t&&t(),e._flushQueue.length>0?setTimeout(function(){return e._flush(e._flushQueue.shift())},e._sendingTimer):(e._isCurrentlyFlushing=!1,e._inboundQueues[0].length>0&&(e._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},e._sendingTimer)))})},t._checkPrimaryInboundQueueEmpty=function(t){var e=this;0===this._inboundQueues[0].length?this._checkOutboundQueueEmptyAndSent(t):setTimeout(function(){return e._checkPrimaryInboundQueueEmpty(t)},250)},t._checkOutboundQueueEmptyAndSent=function(t){var e=this;this._running?setTimeout(function(){return e._checkOutboundQueueEmptyAndSent(t)},250):t()},t}();a._outboundQueue=[],a._inboundQueues=[],a._newEventsAllowed=!1,a._killSwitch=new s.default,a._isCurrentlyFlushing=!1,a._flushQueue=[],a._running=!1,a._timeout=-1,a._urlString="?qsp=true&content-type=application%2Fbond-compact-binary&client-id=NO_AUTH&sdk-version="+u.FullVersionString,Object.defineProperty(e,"__esModule",{value:!0}),e.default=a},function(t,e,n){(function(e,i){!function(e,n){t.exports=n()}(0,function(){"use strict";function t(t){return"function"==typeof t||"object"==typeof t&&null!==t}function r(t){return"function"==typeof t}function o(t){Q=t}function s(t){V=t}function u(){return void 0!==G?function(){G(c)}:a()}function a(){var t=setTimeout;return function(){return t(c,1)}}function c(){for(var t=0;t<q;t+=2){(0,Y[t])(Y[t+1]),Y[t]=void 0,Y[t+1]=void 0}q=0}function l(t,e){var n=arguments,i=this,r=new this.constructor(d);void 0===r[tt]&&W(r);var o=i._state;return o?function(){var t=n[o-1];V(function(){return x(o,r,t,i._result)})}():B(i,r,t,e),r}function f(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(d);return m(n,t),n}function d(){}function h(){return new TypeError("You cannot resolve a promise with itself")}function p(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(t){return rt.error=t,rt}}function g(t,e,n,i){try{t.call(e,n,i)}catch(t){return t}}function v(t,e,n){V(function(t){var i=!1,r=g(n,e,function(n){i||(i=!0,e!==n?m(t,n):I(t,n))},function(e){i||(i=!0,b(t,e))},"Settle: "+(t._label||" unknown promise"));!i&&r&&(i=!0,b(t,r))},t)}function T(t,e){e._state===nt?I(t,e._result):e._state===it?b(t,e._result):B(e,void 0,function(e){return m(t,e)},function(e){return b(t,e)})}function y(t,e,n){e.constructor===t.constructor&&n===l&&e.constructor.resolve===f?T(t,e):n===rt?(b(t,rt.error),rt.error=null):void 0===n?I(t,e):r(n)?v(t,e,n):I(t,e)}function m(e,n){e===n?b(e,h()):t(n)?y(e,n,_(n)):I(e,n)}function w(t){t._onerror&&t._onerror(t._result),A(t)}function I(t,e){t._state===et&&(t._result=e,t._state=nt,0!==t._subscribers.length&&V(A,t))}function b(t,e){t._state===et&&(t._state=it,t._result=e,V(w,t))}function B(t,e,n,i){var r=t._subscribers,o=r.length;t._onerror=null,r[o]=e,r[o+nt]=n,r[o+it]=i,0===o&&t._state&&V(A,t)}function A(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var i=void 0,r=void 0,o=t._result,s=0;s<e.length;s+=3)i=e[s],r=e[s+n],i?x(n,i,r,o):r(o);t._subscribers.length=0}}function S(){this.error=null}function C(t,e){try{return t(e)}catch(t){return ot.error=t,ot}}function x(t,e,n,i){var o=r(n),s=void 0,u=void 0,a=void 0,c=void 0;if(o){if(s=C(n,i),s===ot?(c=!0,u=s.error,s.error=null):a=!0,e===s)return void b(e,p())}else s=i,a=!0;e._state!==et||(o&&a?m(e,s):c?b(e,u):t===nt?I(e,s):t===it&&b(e,s))}function E(t,e){try{e(function(e){m(t,e)},function(e){b(t,e)})}catch(e){b(t,e)}}function k(){return st++}function W(t){t[tt]=st++,t._state=void 0,t._result=void 0,t._subscribers=[]}function P(t,e){this._instanceConstructor=t,this.promise=new t(d),this.promise[tt]||W(this.promise),z(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?I(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&I(this.promise,this._result))):b(this.promise,R())}function R(){return new Error("Array Methods must be provided an Array")}function L(t){return new P(this,t).promise}function O(t){var e=this;return new e(z(t)?function(n,i){for(var r=t.length,o=0;o<r;o++)e.resolve(t[o]).then(n,i)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function D(t){var e=this,n=new e(d);return b(n,t),n}function U(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function M(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function N(t){this[tt]=k(),this._result=this._state=void 0,this._subscribers=[],d!==t&&("function"!=typeof t&&U(),this instanceof N?E(this,t):M())}function F(){var t=void 0;if(void 0!==i)t=i;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;if(e){var n=null;try{n=Object.prototype.toString.call(e.resolve())}catch(t){}if("[object Promise]"===n&&!e.cast)return}t.Promise=N}var j=void 0;j=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var z=j,q=0,G=void 0,Q=void 0,V=function(t,e){Y[q]=t,Y[q+1]=e,2===(q+=2)&&(Q?Q(c):$())},H="undefined"!=typeof window?window:void 0,K=H||{},Z=K.MutationObserver||K.WebKitMutationObserver,X="undefined"==typeof self&&void 0!==e&&"[object process]"==={}.toString.call(e),J="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,Y=new Array(1e3),$=void 0;$=X?function(){return function(){return e.nextTick(c)}}():Z?function(){var t=0,e=new Z(c),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}():J?function(){var t=new MessageChannel;return t.port1.onmessage=c,function(){return t.port2.postMessage(0)}}():void 0===H?function(){try{var t=n(35);return G=t.runOnLoop||t.runOnContext,u()}catch(t){return a()}}():a();var tt=Math.random().toString(36).substring(16),et=void 0,nt=1,it=2,rt=new S,ot=new S,st=0;return P.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===et&&n<t;n++)this._eachEntry(e[n],n)},P.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,i=n.resolve;if(i===f){var r=_(t);if(r===l&&t._state!==et)this._settledAt(t._state,e,t._result);else if("function"!=typeof r)this._remaining--,this._result[e]=t;else if(n===N){var o=new n(d);y(o,t,r),this._willSettleAt(o,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(i(t),e)},P.prototype._settledAt=function(t,e,n){var i=this.promise;i._state===et&&(this._remaining--,t===it?b(i,n):this._result[e]=n),0===this._remaining&&I(i,this._result)},P.prototype._willSettleAt=function(t,e){var n=this;B(t,void 0,function(t){return n._settledAt(nt,e,t)},function(t){return n._settledAt(it,e,t)})},N.all=L,N.race=O,N.resolve=f,N.reject=D,N._setScheduler=o,N._setAsap=s,N._asap=V,N.prototype={constructor:N,then:l,catch:function(t){return this.then(null,t)}},N.polyfill=F,N.Promise=N,N})}).call(e,n(22),n(33))},function(t,e){function n(t){this.message=t}function i(t){var e=String(t).replace(/=+$/,"");if(e.length%4==1)throw new n("'atob' failed: The string to be decoded is not correctly encoded.");for(var i,o,s=0,u=0,a="";o=e.charAt(u++);~o&&(i=s%4?64*i+o:o,s++%4)?a+=String.fromCharCode(255&i>>(-2*s&6)):0)o=r.indexOf(o);return a}var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";n.prototype=new Error,n.prototype.name="InvalidCharacterError",t.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||i},function(t,e,n){function i(t){return decodeURIComponent(r(t).replace(/(.)/g,function(t,e){var n=e.charCodeAt(0).toString(16).toUpperCase();return n.length<2&&(n="0"+n),"%"+n}))}var r=n(19);t.exports=function(t){var e=t.replace(/-/g,"+").replace(/_/g,"/");switch(e.length%4){case 0:break;case 2:e+="==";break;case 3:e+="=";break;default:throw"Illegal base64url string!"}try{return i(e)}catch(t){return r(e)}}},function(t,e,n){"use strict";function i(t){this.message=t}var r=n(20);i.prototype=new Error,i.prototype.name="InvalidTokenError",t.exports=function(t,e){if("string"!=typeof t)throw new i("Invalid token specified");e=e||{};var n=!0===e.header?0:1;try{return JSON.parse(r(t.split(".")[n]))}catch(t){throw new i("Invalid token specified: "+t.message)}},t.exports.InvalidTokenError=i},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function r(t){if(l===setTimeout)return setTimeout(t,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(t,0);try{return l(t,0)}catch(e){try{return l.call(null,t,0)}catch(e){return l.call(this,t,0)}}}function o(t){if(f===clearTimeout)return clearTimeout(t);if((f===i||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function s(){_&&h&&(_=!1,h.length?p=h.concat(p):g=-1,p.length&&u())}function u(){if(!_){var t=r(s);_=!0;for(var e=p.length;e;){for(h=p,p=[];++g<e;)h&&h[g].run();g=-1,e=p.length}h=null,_=!1,o(t)}}function a(t,e){this.fun=t,this.array=e}function c(){}var l,f,d=t.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(t){l=n}try{f="function"==typeof clearTimeout?clearTimeout:i}catch(t){f=i}}();var h,p=[],_=!1,g=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];p.push(new a(t,e)),1!==p.length||_||r(u)},a.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=c,d.addListener=c,d.once=c,d.off=c,d.removeListener=c,d.removeAllListeners=c,d.emit=c,d.prependListener=c,d.prependOnceListener=c,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";function i(t){return o=o||new Promise(function(e,i){t.authToken?(n.i(s.a)(c,t.authToken),e(t.authToken)):t.getAuthToken(function(t,r){t?(n.i(s.a)(c,t),e(t)):i(new u.a("GetAuthTokenError","Auth token is undefined",r))},function(t,e){i(new u.a("GetAuthTokenError",t,e))})})}function r(t){if(!t)throw Error("Empty AuthToken");var e=a(t);return{tenantId:e.tid,userAadId:e.oid,userPuid:e.puid,expirationTimeEpoch:e.exp}}e.a=i,e.b=r;var o,s=n(30),u=n(0),a=n(21),c=(n.n(a),"LokiAuthToken")},function(t,e,n){"use strict";function i(t,e){return o=o||new Promise(function(i,o){var c=new XMLHttpRequest,l=r(e);c.open("GET",l,!0),c.setRequestHeader("authToken",t),c.setRequestHeader("Accept","application/json");var h=n.i(u.a)();c.setRequestHeader("X-RootCorrelationId",h),c.setRequestHeader("X-CorrelationId",h),c.setRequestHeader("X-ClientCorrelationId",e.clientCorrelationId),c.setRequestHeader("X-ClientType",e.clientType);var p=n.i(s.a)(d);p&&c.setRequestHeader(d,p),c.addEventListener("load",function(){if(200===c.status)try{var t=JSON.parse(c.response);t.RootCorrelationId=h,t.LokiVersion=c.getResponseHeader("x-serverversion")||"",i(t)}catch(t){o(new a.a("GetLokiConfigError","Failed to parse initialization config.",h))}else o(new a.a("GetLokiConfigError","Couldn't retrieve initialization config. Status code is "+c.status,h))}),c.addEventListener("error",function(){o(new a.a("GetLokiConfigError","Couldn't retrieve initialization config, request failed to complete.",h))}),c.addEventListener("timeout",function(){o(new a.a("GetLokiConfigError","Loki config request timed out after "+f+" ms.",h))}),c.timeout=f,c.send()})}function r(t){var e=n.i(s.a)(h),i=e||t.culture;return"ppe"===t.region||"df"===t.region||"msit"===t.region?c.replace("{0}",t.region).replace("{1}",t.clientType).replace("{2}",i):l.replace("{0}",t.clientType).replace("{1}",i)}e.a=i;var o,s=n(7),u=n(27),a=n(0),c="https://{0}.loki.delve.office.com/api/v1/configuration/{1}/{2}",l="https://loki.delve.office.com/api/v1/configuration/{0}/{1}",f=6e4,d="LivePersonaCardVersionOverride",h="LivePersonaCardCultureOverride"},function(t,e,n){"use strict";function i(t){if(!o){var e=t.Resources[l],i=void 0;n.i(u.a)("lpcUseLocalBuild")?(e="https://localhost:3333/assets/livepersonacardstrings.js",i="https://localhost:3333/assets/livepersonacard.js"):i=r()?t.Resources[c]:t.Resources[a],o=Promise.all([n.i(s.a)(e),n.i(s.a)(i)])}return o}function r(){return window.React&&window.React.version&&0===window.React.version.indexOf("15.")&&window.ReactDOM&&window.ReactDOM.version&&0===window.ReactDOM.version.indexOf("15.")}e.a=i;var o,s=n(28),u=n(7),a="livepersonacard_full",c="livepersonacard_global",l="livepersonacardstrings"},function(t,e,n){"use strict";function i(t,e,n){return s=s||new Promise(function(i,o){try{var s=r(t,e,n);window.LPC.start(s),i()}catch(t){o(new u.a("StartLivePersonaCardError",t.name+" "+t.message))}})}function r(t,e,n){return{refreshAuthToken:o(e),logToExternalApplication:e.logMessage,logToExternalAria:function(t,e){t.tenantToken=e,a.AWT.logEvent(t)},contextType:e.clientContextType,strings:window.LivePersonaCardStrings.strings,source:e.clientType,consumerCorrelationId:e.clientCorrelationId,activeFlights:t.Flights,performanceTimings:n.getAllTimings(),isDebug:!1,region:e.region,culture:e.culture,dataCallbacks:e.dataCallbacks,actionCallbacks:e.actionCallbacks,privateDataCallbacks:e.privateDataCallbacks,privateActionCallbacks:e.privateActionCallbacks,options:e.options?e.options:{isImmersiveProfileEnabled:!1,isLinkedInIntegrationEnabled:!1,hideDocumentFilter:!1},lokiUrl:t.LokiUrl,lokiVersion:t.LokiVersion,tenantAadObjectId:e.tenantAadObjectId,userAadObjectId:e.userAadObjectId,userPuid:e.userPuid}}function o(t){return function(e){t.getAuthToken(function(t,n){e(t,"",n)},function(t,n){e("",t,n)})}}e.a=i;var s,u=n(0),a=n(5);n.n(a)},function(t,e,n){"use strict";function i(){return r.replace(/[xy]/g,function(t){var e;if(window.crypto){var n=new Uint8Array(1);window.crypto.getRandomValues(n),e=n[0]}else e=Math.floor(16*Math.random());return("x"===t?e%16:e%4+8).toString(16)})}e.a=i;var r="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"},function(t,e,n){"use strict";function i(t){return new Promise(function(e,n){var i=document.createElement("script");i.type="text/javascript",i.crossOrigin="anonymous",i.src=t,i.addEventListener("load",function(){e()}),i.addEventListener("error",function(){n(new r.a("LoadScriptError","Unexpected error while loading script on page."))}),document.body.appendChild(i)})}e.a=i;var r=n(0)},function(t,e,n){"use strict";n.d(e,"b",function(){return i}),n.d(e,"a",function(){return r});var i;!function(t){t.getAuthToken="GetAuthTokenFromStartDuration",t.getLokiConfig="GetLokiConfigFromStartDuration",t.getLpcBundles="GetLpcBundlesFromStartDuration"}(i||(i={}));var r=function(){function t(){this.start=this.getCurrentTime(),this.timings={}}return t.prototype.measureFromStart=function(t){this.timings[t]=Math.round(this.getCurrentTime()-this.start)},t.prototype.getAllTimings=function(){var t=this;if(window.performance&&"function"==typeof window.performance.getEntriesByType){var e=window.performance.getEntriesByType("resource");e&&e.forEach(function(e){if(e&&e.name){var n=e.name.toLowerCase(),i=!1;-1!==n.indexOf("authtoken/loki")?(n="AuthRequestDuration",i=!0):-1!==n.indexOf("/lpc/versionless/livepersonacard_")?(n="LpcBundleRequestDuration",i=!0):-1!==n.indexOf("/lpc/versionless/livepersonacardstrings")?(n="LpcStringsRequestDuration",i=!0):-1!==n.indexOf("/api/v1/configuration/")&&(n="InitConfigRequestDuration",i=!0),i&&(t.timings[n]=Math.round(e.duration))}})}return this.timings},t.prototype.getCurrentTime=function(){return window.performance&&"function"==typeof window.performance.now?performance.now():Date.now()},t}()},function(t,e,n){"use strict";function i(t,e){try{sessionStorage&&sessionStorage.setItem&&sessionStorage.setItem(t,e)}catch(t){}}e.a=i},function(t,e,n){"use strict";function i(t){return void 0===t||"string"!=typeof t||""===t||null===t}function r(t){return void 0===t||"function"!=typeof t}e.a=i,e.b=r},function(t,e,n){"use strict";function i(t){return new Promise(function(e,n){var i=r(t);i?n(new s.a("ValidateBootstrapperConfigError",i)):e()})}function r(t){var e="";if(t){var i=[];n.i(o.a)(t.culture)&&i.push("culture"),n.i(o.a)(t.clientType)&&i.push("clientType"),n.i(o.a)(t.clientContextType)&&i.push("clientContextType"),n.i(o.a)(t.clientCorrelationId)&&i.push("clientCorrelationId"),n.i(o.b)(t.logMessage)&&i.push("logMessage"),n.i(o.b)(t.getAuthToken)&&i.push("getAuthToken"),i.length>0&&(e="Invalid required parameter(s): "+i.join(", ")+". Check the values and types you're passing."),t.region&&-1===u.indexOf(t.region.toLowerCase().trim())&&(e+="Invalid region value. Allowed values are: empty string for production environments, and "+u.join(", ")+" for pre-production environments.")}else e="Config must be defined.";return e}e.a=i;var o=n(31),s=n(0),u=["msit","df","ppe"]},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e){t.exports="1.3.14"},function(t,e){},function(t,e,n){t.exports=n(8)}])});

/***/ }),

/***/ 2655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var PersonaCard_1 = __webpack_require__(2710);
var Store_1 = __webpack_require__(327);
var initializeLivePersonaCard_1 = __webpack_require__(2713);
var owa_people_loki_1 = __webpack_require__(2644);
var owa_string_utils_1 = __webpack_require__(2627);
var mobx_react_1 = __webpack_require__(11);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var HOVER_DELAY_MS = 500;
var LivePersonaCardPersonaTypes = {
    NotResolved: 'NotResolved',
    User: 'User',
    Group: 'Group',
    External: 'External',
    DistributionList: 'DistributionList',
    PrivateDistributionList: 'PrivateDistributionList',
    Location: 'Location',
    Room: 'Room',
    Meeting: 'Meeting',
};
var personaCardDiv;
var LegacyPersonaCardBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyPersonaCardBehavior, _super);
    function LegacyPersonaCardBehavior(props) {
        var _this = _super.call(this, props) || this;
        _this.onElementClicked = function (ev) {
            ev.stopPropagation();
            _this.openPersonaCard();
        };
        _this.openPersonaCard = function () {
            if (!personaCardDiv) {
                personaCardDiv = document.createElement('div');
                personaCardDiv.id = 'personaCard';
                document.body.appendChild(personaCardDiv);
            }
            var _a = _this.props, name = _a.name, emailAddress = _a.emailAddress;
            if (name && emailAddress) {
                ReactDOM.render(React.createElement(PersonaCard_1.default, { emailAddress: emailAddress, name: name, targetElement: _this.wrappedElement, onDismiss: _this.closePersonaCard }), personaCardDiv);
            }
        };
        _this.closePersonaCard = function (ev) {
            ReactDOM.unmountComponentAtNode(personaCardDiv);
        };
        _this.onElementHover = function () {
            _this.openPersonaCard();
        };
        _this.onElementMouseEnter = function (ev) {
            _this.hoverTimerId = setTimeout(_this.onElementHover, HOVER_DELAY_MS);
        };
        _this.onElementMouseLeave = function (ev) {
            if (_this.hoverTimerId) {
                clearTimeout(_this.hoverTimerId);
                _this.hoverTimerId = undefined;
            }
        };
        _this.getElement = function (wrappedElement) {
            _this.wrappedElement = ReactDOM.findDOMNode(wrappedElement);
        };
        return _this;
    }
    LegacyPersonaCardBehavior.prototype.render = function () {
        return (React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props, { onPersonaCardBehaviorClick: this.onElementClicked, onPersonaCardBehaviorMouseEnter: this.onElementMouseEnter, onPersonaCardBehaviorMouseLeave: this.onElementMouseLeave, ref: this.getElement })));
    };
    return LegacyPersonaCardBehavior;
}(React.Component));
var LivePersonaCardBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(LivePersonaCardBehavior, _super);
    function LivePersonaCardBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LivePersonaCardBehavior.prototype.componentDidMount = function () {
        initializeLivePersonaCard_1.default(this.props.composeEmailOverride);
    };
    LivePersonaCardBehavior.prototype.render = function () {
        if (Store_1.default.isLivePersonaCardInitialized) {
            var LivePersonaCardHoverTarget = window.LivePersonaCardHoverTarget;
            return (React.createElement(LivePersonaCardHoverTarget, { upn: this.props.emailAddress, externalAppSessionCorrelationId: owa_people_loki_1.lokiClientCorrelationId, disableHoverAndKeyPress: this.props.disableHoverAndKeyPress, hostAppPersonaInfo: {
                    PersonaType: calculatePersonaType(this.props.mailBoxType, this.props.personaType),
                    PersonaDisplayName: this.props.name,
                    OlsPersonaId: this.props.olsPersonaId,
                } },
                React.createElement("span", { className: this.props.className, "aria-label": this.props.ariaLabel },
                    React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props)))));
        }
        else {
            return React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props));
        }
    };
    LivePersonaCardBehavior = tslib_1.__decorate([
        mobx_react_1.observer
    ], LivePersonaCardBehavior);
    return LivePersonaCardBehavior;
}(React.Component));
function calculatePersonaType(mailBoxType, personaType) {
    if (!owa_string_utils_1.isNullOrWhiteSpace(mailBoxType)) {
        return getLivePersonaCardPersonaTypeFromMailBoxType(mailBoxType);
    }
    if (!owa_string_utils_1.isNullOrWhiteSpace(personaType) &&
        Object.keys(LivePersonaCardPersonaTypes).indexOf(personaType) > -1) {
        return personaType;
    }
    if (owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')) {
        return 'User';
    }
    return 'NotResolved';
}
function getLivePersonaCardPersonaTypeFromMailBoxType(mailBoxType) {
    switch (mailBoxType) {
        case 'PublicDL':
            return LivePersonaCardPersonaTypes.DistributionList;
        case 'PrivateDL':
            return LivePersonaCardPersonaTypes.PrivateDistributionList;
        case 'GroupMailbox':
            return LivePersonaCardPersonaTypes.Group;
        case 'Mailbox':
        case 'Contact':
        case 'OneOff':
            return LivePersonaCardPersonaTypes.User;
        case 'Unknown':
            return LivePersonaCardPersonaTypes.NotResolved;
        default:
            return LivePersonaCardPersonaTypes.User;
    }
}
function personaCardBehavior(InputTemplate) {
    return mobx_react_1.observer(/** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var ComponentClass = owa_controls_feature_flags_1.isControlFeatureEnabled('rp-livePersonaCard')
                ? LivePersonaCardBehavior
                : LegacyPersonaCardBehavior;
            return React.createElement(ComponentClass, tslib_1.__assign({ InputTemplate: InputTemplate }, this.props));
        };
        return class_1;
    }(React.Component)));
}
exports.personaCardBehavior = personaCardBehavior;
//# sourceMappingURL=PersonaCardBehavior.js.map

/***/ }),

/***/ 2676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a given string is null, empty, or consists only of white-space characters.
 * @param text: the string to check
 */
function isNullOrWhiteSpace(text) {
    return text == null || text.trim().length == 0;
}
exports.isNullOrWhiteSpace = isNullOrWhiteSpace;
//# sourceMappingURL=isNullOrWhiteSpace.js.map

/***/ }),

/***/ 2678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getClientAccessTokenJsonRequest_1 = __webpack_require__(2679);
function getClientAccessTokenOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getClientAccessTokenJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetClientAccessToken", req, options);
}
exports.default = getClientAccessTokenOperation;


/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getClientAccessTokenJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetClientAccessTokenJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = getClientAccessTokenJsonRequest;


/***/ }),

/***/ 2680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getClientAccessTokenRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetClientAccessTokenRequest:#Exchange' }, data);
    return result;
}
exports.default = getClientAccessTokenRequest;


/***/ }),

/***/ 2710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var PersonaControl_1 = __webpack_require__(673);
var Callout_1 = __webpack_require__(157);
var Persona_1 = __webpack_require__(234);
var styles = __webpack_require__(2711);
var PersonaCard = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaCard, _super);
    function PersonaCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseLeave = function (ev) {
            _this.props.onDismiss(ev);
        };
        return _this;
    }
    PersonaCard.prototype.render = function () {
        var _a = this.props, emailAddress = _a.emailAddress, name = _a.name, targetElement = _a.targetElement, onDismiss = _a.onDismiss;
        if (!targetElement) {
            return null;
        }
        return (React.createElement(Callout_1.Callout, { target: targetElement, directionalHint: 4 /* bottomLeftEdge */, isBeakVisible: false, onDismiss: onDismiss },
            React.createElement("div", { onMouseLeave: this.onMouseLeave, className: styles.container },
                React.createElement(PersonaControl_1.default, { name: name, emailAddress: emailAddress, size: Persona_1.PersonaSize.large, showPersonaDetails: true, secondaryText: emailAddress }))));
    };
    PersonaCard = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaCard);
    return PersonaCard;
}(React.Component));
exports.default = PersonaCard;
//# sourceMappingURL=PersonaCard.js.map

/***/ }),

/***/ 2711:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2712);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2ZbqoLMzvSVTB15DLsl21H{padding:10px}._2ZbqoLMzvSVTB15DLsl21H .ms-Persona-details{-webkit-touch-callout:text;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:auto}", ""]);

// exports
exports.locals = {
	"container": "_2ZbqoLMzvSVTB15DLsl21H"
};

/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var initializeLivePersonaCardAsync_1 = __webpack_require__(2714);
var Store_1 = __webpack_require__(327);
var owa_trace_1 = __webpack_require__(14);
var owa_bundling_1 = __webpack_require__(6);
var lazyStyles = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 2936));
});
var handleInitializeLivePersonaCard = legacy_1.action('handleInitializeLivePersonaCard')(function () {
    Store_1.default.isLivePersonaCardInitialized = true;
});
var livePersonaCardFailedToInitialize = false;
var initializationPromise = null;
exports.default = legacy_1.action('initializeLivePersonaCard')(function initializeLivePersonaCard(composeEmailOverride) {
    if (!initializationPromise &&
        !Store_1.default.isLivePersonaCardInitialized &&
        !livePersonaCardFailedToInitialize) {
        // TMP: Dynamically load css for card.  LPC will eventually fix this
        // and ship with the required fonts.
        lazyStyles.import();
        initializationPromise = initializeLivePersonaCardAsync_1.default(composeEmailOverride)
            .then(handleInitializeLivePersonaCard)
            .catch(function (reason) {
            initializationPromise = null;
            livePersonaCardFailedToInitialize = true;
            owa_trace_1.trace.error(reason);
        });
    }
});
//# sourceMappingURL=initializeLivePersonaCard.js.map

/***/ }),

/***/ 2714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_analytics_1 = __webpack_require__(12);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_people_loki_1 = __webpack_require__(2644);
var getPersonaPhotoUrl_1 = __webpack_require__(345);
var getHexConsumerIdForUser_1 = __webpack_require__(1579);
var Persona_1 = __webpack_require__(234);
var getPersonaPhotoUrl_2 = __webpack_require__(345);
var store_1 = __webpack_require__(49);
var personaConfig_1 = __webpack_require__(1777);
var initializeLivePersonaCardPromise;
function initializeLivePersonaCardAsync(composeEmailOverride) {
    var config = personaConfig_1.getConfig();
    initializeLivePersonaCardPromise =
        initializeLivePersonaCardPromise ||
            new Promise(function (resolve, reject) {
                var actionCallbacks = {
                    composeMail: function (recipient, subject, body) {
                        if (composeEmailOverride) {
                            composeEmailOverride(recipient, recipient);
                        }
                        else if (config.actionCallbacks && config.actionCallbacks.composeMail) {
                            config.actionCallbacks.composeMail(recipient, subject, body);
                        }
                        // Compose view is triggered in existing window, therefore dismiss card so it's not left hanging without an anchor
                        window.LPC.dismissCard();
                    },
                };
                var dataCallbacks = {
                    getAndPrefetchPersonaImageUri: function (personaId, callback) {
                        var hexCid = getHexConsumerIdForUser_1.default(personaId.Smtp);
                        callback(hexCid
                            ? getPersonaPhotoUrl_2.getPersonaPhotoUrlFromhexCID(hexCid, Persona_1.PersonaSize.regular)
                            : getPersonaPhotoUrl_1.default(personaId.Smtp));
                    },
                };
                if (config.actionCallbacks && config.actionCallbacks.toggleFavoritePerson) {
                    actionCallbacks.toggleFavoritePerson = config.actionCallbacks.toggleFavoritePerson;
                }
                if (config.dataCallbacks && config.dataCallbacks.getIsPersonFavorited) {
                    dataCallbacks.getIsPersonFavorited = config.dataCallbacks.getIsPersonFavorited;
                }
                var isConsumer = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
                var culture = store_1.default.userConfiguration.SessionSettings.UserCulture;
                var tenantId = store_1.default.userConfiguration.SessionSettings.TenantGuid;
                var useDogfood = owa_controls_feature_flags_1.isControlFeatureEnabled('peo-lokiDogfood');
                var timeFormat = store_1.default.userConfiguration.UserOptions.TimeFormat;
                var is24HourFormat = timeFormat && timeFormat.indexOf('tt') === -1;
                var logger = function (eventName, customData) {
                    owa_analytics_1.logUsage(eventName, customData);
                };
                owa_people_loki_1.initializeLoki({
                    culture: culture,
                    isConsumer: isConsumer,
                    useDogfood: useDogfood,
                    logger: logger,
                    tenantId: tenantId,
                });
                var bootstrapperConfig = owa_people_loki_1.getLokiBootstrapperConfig();
                var lpcBootstrapperConfig = tslib_1.__assign({}, bootstrapperConfig, { actionCallbacks: actionCallbacks, dataCallbacks: dataCallbacks, options: {
                        isLinkedInIntegrationEnabled: false,
                        timeFormat: timeFormat,
                        is24HourFormat: is24HourFormat,
                    } });
                owa_people_loki_1.initializeLivePersonaCard(lpcBootstrapperConfig, function () {
                    resolve();
                }, function (errorMessage) {
                    reject(errorMessage);
                });
            });
    return initializeLivePersonaCardPromise;
}
exports.default = initializeLivePersonaCardAsync;
//# sourceMappingURL=initializeLivePersonaCardAsync.js.map

/***/ }),

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authToken_1 = __webpack_require__(2647);
exports.AuthToken = authToken_1.AuthToken;
var authTokenProvider_1 = __webpack_require__(2723);
exports.AuthTokenProvider = authTokenProvider_1.AuthTokenProvider;
var authUtils_1 = __webpack_require__(2649);
exports.getAuthToken = authUtils_1.getAuthToken;
exports.setAuthToken = authUtils_1.setAuthToken;
exports.setAuthTokenOnUrl = authUtils_1.setAuthTokenOnUrl;
exports.clearAuthToken = authUtils_1.clearAuthToken;
exports.removeAuthTokenFromUrl = authUtils_1.removeAuthTokenFromUrl;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = __webpack_require__(2648);
function isLokiEndpoint(url) {
    if (StringUtils_1.isNullOrEmpty(url)) {
        return false;
    }
    var regex = new RegExp("^https://.+.loki.delve.office.com/.*", "i");
    return regex.test(url);
}
exports.isLokiEndpoint = isLokiEndpoint;
//# sourceMappingURL=isLokiEndpoint.js.map

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copied from Oslo code
// General base64 util based on this repo https://github.com/mathiasbynens/base64
// If you want to modify/change this code, consider this package instead - https://www.npmjs.com/package/atob
Object.defineProperty(exports, "__esModule", { value: true });
// This is just used for browsers <= IE9, for normal browsers use btoa and atob
var TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// From http://whatwg.org/html/common-microsyntaxes.html#space-character
var REGEX_SPACE_CHARACTERS = /<%= spaceCharacters %>/g;
/**
 * `decode` is designed to be fully compatible with `atob` as described in the
 * HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
 */
/* tslint:disable:no-bitwise */
function decode(input) {
    input = String(input).replace(REGEX_SPACE_CHARACTERS, "");
    var length = input.length;
    if (length % 4 === 0) {
        input = input.replace(/==?$/, "");
        length = input.length;
    }
    if (length % 4 === 1 || /[^+a-zA-Z0-9/]/.test(input)) {
        error("Invalid character: the string to be decoded is not correctly encoded.");
    }
    var bitCounter = 0;
    var bitStorage = 0;
    var buffer;
    var output = "";
    var position = -1;
    while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
        // Unless this is the first of a group of 4 characters…
        if (bitCounter++ % 4) {
            // …convert the first 8 bits to a single ASCII character.
            output += String.fromCharCode(0xff & (bitStorage >> ((-2 * bitCounter) & 6)));
        }
    }
    return output;
}
exports.decode = decode;
/** `encode` is designed to be fully compatible with `btoa` as described in the
 *  HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
 */
function encode(input) {
    input = String(input);
    if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // Matched, and the input is supposed to only contain ASCII anyway.
        error("The string to be encoded contains characters outside of the 'Latin1 range.");
    }
    var padding = input.length % 3;
    var output = "";
    var position = -1;
    var a;
    var b;
    var c;
    var buffer;
    // Make sure any padding is handled outside of the loop.
    var length = input.length - padding;
    while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c;
        // Turn the 24 bits into four chunks of 6 bits each, and append the
        // Matching character for each of them to the output.
        output +=
            TABLE.charAt((buffer >> 18) & 0x3f) +
                TABLE.charAt((buffer >> 12) & 0x3f) +
                TABLE.charAt((buffer >> 6) & 0x3f) +
                TABLE.charAt(buffer & 0x3f);
    }
    if (padding === 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt((buffer >> 4) & 0x3f) + TABLE.charAt((buffer << 2) & 0x3f) + "=";
    }
    else if (padding === 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt((buffer << 4) & 0x3f) + "==";
    }
    return output;
}
exports.encode = encode;
function error(message) {
    var error = new Error(message);
    error.name = "InvalidCharacterError";
    throw new Error(message);
}
//# sourceMappingURL=Base64.js.map

/***/ }),

/***/ 2718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filters out null and undefined values from an array.
 * @param array The array to filter.
 */
function filterOutNull(array) {
    return array.filter(function (x) { return x !== null && x !== undefined; });
}
exports.filterOutNull = filterOutNull;
/**
 * Returns copy of the given object with all null, undefined, empty string and empty array values removed.
 *
 * The return type isn't totally correct, since it claims that we _can_ return keys with undefined values. It would be neat if we could
 * apply Partial only to the falsyable values, but at least we preserve a defensive version of the incoming type, so that you can't
 * accidentally pass the output to something expecting something completely different.
 */
function omitEmpty(o) {
    return pickBy(o, function (val) { return val !== undefined && val !== null && val !== "" && (!(val instanceof Array) || val.length > 0); });
}
exports.omitEmpty = omitEmpty;
function pickBy(o, pred) {
    if (o === undefined || o === null) {
        return o;
    }
    var ret = {};
    for (var _i = 0, _a = Object.keys(o); _i < _a.length; _i++) {
        var key = _a[_i];
        if (pred(o[key])) {
            ret[key] = o[key];
        }
    }
    return ret;
}
/*
 * Given a "current" and an "update" object, return a new object with the merged properties of current and update, with precedence given to
 * update. The function ensures that update is an exact subset of current. I.e. update cannot (normally) introduce any keys that don't
 * already exist in current.
 *
 * The exception to this rule occurs if update is _not_ a literal object and contains extra properties _in addition_ to all the properties
 * in current. This is an effect of the type checking system, which tends to be more relaxed about object expressions than literal objects.
 *
 * As an example:
 *
 * Given interface I { a: number, b: number},
 * keyof I is "a" | "b"
 * [key in K]: I[K] is an indexer mapping keys to their respective types in I. This will fail for keys that are not in I, since they cannot
 * be mapped.
 *
 * This signature looks very much like Partial<T> and is indeed almost the same thing. However, since Partial marks all its properties as
 * optional, all of them will have undefined as a valid type. We very much don't want the update object to accidentally set non-nullable
 * properties to undefined, so this means we can't use Partial<T>
 */
function updateWith(current, update) {
    return Object.assign({}, current, update);
}
exports.updateWith = updateWith;
//# sourceMappingURL=Functional.js.map

/***/ }),

/***/ 2719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MemoryStorageUtils = __webpack_require__(2720);
var SessionStorageUtils = __webpack_require__(2721);
function clear(appId) {
    MemoryStorageUtils.clear(appId);
    SessionStorageUtils.clear();
}
exports.clear = clear;
function setItem(key, value, appId) {
    MemoryStorageUtils.setItem(key, value, appId);
    SessionStorageUtils.setItem(key, value);
}
exports.setItem = setItem;
function getItem(key, appId) {
    var val = SessionStorageUtils.getItem(key);
    if (val !== undefined) {
        return val;
    }
    return MemoryStorageUtils.getItem(key, appId);
}
exports.getItem = getItem;
function removeItem(key, appId) {
    MemoryStorageUtils.removeItem(key, appId);
    SessionStorageUtils.removeItem(key);
}
exports.removeItem = removeItem;
//# sourceMappingURL=StorageUtils.js.map

/***/ }),

/***/ 2720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var memoryStorage = new Map();
function clear(appId) {
    memoryStorage.delete(appId);
}
exports.clear = clear;
function setItem(key, value, appId) {
    var map = memoryStorage.get(appId) || new Map();
    map.set(key, value);
    memoryStorage.set(appId, map);
}
exports.setItem = setItem;
function getItem(key, appId) {
    var map = memoryStorage.get(appId);
    return map ? map.get(key) : undefined;
}
exports.getItem = getItem;
function removeItem(key, appId) {
    var map = memoryStorage.get(appId);
    if (map) {
        map.delete(key);
    }
}
exports.removeItem = removeItem;
//# sourceMappingURL=MemoryStorageUtils.js.map

/***/ }),

/***/ 2721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function clear() {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.clear();
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.clear = clear;
function setItem(key, value) {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.setItem(key, value);
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.setItem = setItem;
function getItem(key) {
    if (window.sessionStorage) {
        try {
            var val = window.sessionStorage.getItem(key);
            return val === null ? undefined : val;
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
    return undefined;
}
exports.getItem = getItem;
function removeItem(key) {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.removeItem(key);
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.removeItem = removeItem;
//# sourceMappingURL=SessionStorageUtils.js.map

/***/ }),

/***/ 2722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getUrlParameter(name, searchString) {
    if (searchString === void 0) { searchString = window.location.search; }
    var param = searchString
        .substr(1)
        .split("&")
        .map(function (e) { return e.split("=").map(function (f) { return decodeURIComponent(f); }); })
        .filter(function (u) { return u[0] === name; });
    return param[0] && param[0][1];
}
exports.getUrlParameter = getUrlParameter;
//# sourceMappingURL=UrlUtils.js.map

/***/ }),

/***/ 2723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authToken_1 = __webpack_require__(2647);
var authUtils_1 = __webpack_require__(2649);
var GET_AUTH_TOKEN_SCENARIO = "LokiGetAuthToken";
var GET_AUTH_TOKEN_FAILED = "LokiGetAuthTokenFailed";
/**
 * A guy you need to ask to getAuthToken and it will keep your worries away
 */
var AuthTokenProvider = (function () {
    function AuthTokenProvider(getAppId, refreshAuthToken, logger, runWithLogMonitor, authTokenType, loggingFeature) {
        if (authTokenType === void 0) { authTokenType = authToken_1.AuthToken; }
        if (loggingFeature === void 0) { loggingFeature = "RESTAuthToken"; }
        this.getAppId = getAppId;
        this.refreshAuthToken = refreshAuthToken;
        this.logger = logger;
        this.runWithLogMonitor = runWithLogMonitor;
        this.authTokenType = authTokenType;
        this.loggingFeature = loggingFeature;
        this.getAuthToken();
    }
    AuthTokenProvider.prototype.getAuthToken = function () {
        var _this = this;
        // Try getting a valid token we already have
        if (this.authToken && this.authToken.isValid()) {
            return Promise.resolve(this.authToken);
        }
        // Try getting the token from cache
        this.authToken = new this.authTokenType(authUtils_1.getAuthToken(this.getAppId()), this.loggingFeature, this.logger);
        if (this.authToken.isValid()) {
            return Promise.resolve(this.authToken);
        }
        this.authPromise =
            this.authPromise ||
                new Promise(function (resolve, reject) {
                    if (_this.runWithLogMonitor) {
                        _this.runWithLogMonitor({
                            scenarioName: GET_AUTH_TOKEN_SCENARIO,
                            feature: _this.loggingFeature,
                            operation: function () { return _this.authToken.refresh(_this.refreshAuthToken); },
                            successAction: function (token) {
                                _this.onRefreshAuthTokenSuccess(token);
                                resolve(token);
                            },
                            errorAction: function (reason) {
                                _this.onRefreshAuthTokenError(reason);
                                reject(reason);
                            },
                            treatAsExpectedError: function (error) {
                                return !!navigator && !navigator.onLine;
                            }
                        });
                    }
                    else {
                        _this.authToken
                            .refresh(_this.refreshAuthToken)
                            .then(function (token) {
                            _this.onRefreshAuthTokenSuccess(token);
                            resolve(token);
                        })
                            .catch(function (reason) {
                            _this.onRefreshAuthTokenError(reason);
                            reject(reason);
                        });
                    }
                });
        return this.authPromise;
    };
    AuthTokenProvider.prototype.onRefreshAuthTokenSuccess = function (newToken) {
        this.authPromise = undefined;
        authUtils_1.setAuthToken(this.getAppId(), newToken.getValue() || "");
    };
    AuthTokenProvider.prototype.onRefreshAuthTokenError = function (error) {
        this.authPromise = undefined;
        if (this.logger) {
            this.logger.logError(GET_AUTH_TOKEN_FAILED, this.loggingFeature, { message: error });
        }
    };
    return AuthTokenProvider;
}());
exports.AuthTokenProvider = AuthTokenProvider;
//# sourceMappingURL=authTokenProvider.js.map

/***/ }),

/***/ 2724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getClientAccessTokenOperation_1 = __webpack_require__(2678);
var Utils_1 = __webpack_require__(362);
var getClientAccessTokenRequest_1 = __webpack_require__(2680);
var LokiAuthTokenId = '94c63fef-13a3-47bc-8074-75af8c65887a';
function getLokiAuthTokenAsync() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, results, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: Utils_1.getJsonRequestHeader(),
                        Body: getClientAccessTokenRequest_1.default({
                            TokenRequests: [
                                {
                                    __type: 'TokenRequest:#Exchange',
                                    Id: LokiAuthTokenId,
                                    TokenType: 'Loki',
                                },
                            ],
                        }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getClientAccessTokenOperation_1.default(request)];
                case 2:
                    results = _a.sent();
                    if (results && results.Body.ResponseMessages.Items[0].ResponseClass == 'Success') {
                        return [2 /*return*/, results.Body.ResponseMessages.Items[0].Token.TokenValue];
                    }
                    return [2 /*return*/, null];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.default = getLokiAuthTokenAsync;
//# sourceMappingURL=getLokiAuthTokenAsync.js.map

/***/ }),

/***/ 2725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This endpoint is used to test that Loki is working end to end
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var lokiRequest_1 = __webpack_require__(2726);
function getUserInfo(userSmtp) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var path, queryParameters, response, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    path = 'api/beta/userinfo';
                    queryParameters = {
                        userSmtp: userSmtp,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, lokiRequest_1.lokiRequest('GET', path, queryParameters)];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, response.json()];
                    }
                    return [2 /*return*/, Promise.reject(response.status)];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getUserInfo = getUserInfo;
//# sourceMappingURL=userInfoProvider.js.map

/***/ }),

/***/ 2726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var fetchLokiConfigAsync_1 = __webpack_require__(2727);
var lokiContext = __webpack_require__(2612);
var requestAuthTokenHandler_1 = __webpack_require__(2646);
function lokiRequest(method, path, queryParameters, body, headers) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var config, authToken, url, requestInit;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchLokiConfigAsync_1.fetchLokiConfigAsync()];
                case 1:
                    config = _a.sent();
                    return [4 /*yield*/, requestAuthTokenHandler_1.getAuthToken()];
                case 2:
                    authToken = (_a.sent()).getValue();
                    if (!headers) {
                        headers = new Headers();
                    }
                    headers.set('Accept', 'application/json');
                    headers.set('Content-Type', 'application/json');
                    headers.set('authorization', "Bearer " + authToken);
                    headers.set('X-ClientCorrelationId', lokiContext.clientCorrelationId);
                    headers.set('X-ClientType', lokiContext.clientType);
                    headers.set('X-ClientScenario', lokiContext.clientScenario);
                    headers.set('X-RefererUrl', '');
                    url = addQueryParametersToUrl(config.LokiUrl + path, queryParameters);
                    requestInit = {
                        method: method,
                        headers: headers,
                        body: body,
                    };
                    return [2 /*return*/, fetch(url, requestInit)];
            }
        });
    });
}
exports.lokiRequest = lokiRequest;
function addQueryParametersToUrl(url, queryParameters) {
    var parametersKeys = Object.keys(queryParameters);
    if (parametersKeys.length === 0) {
        return url;
    }
    var parameters = [];
    parametersKeys.forEach(function (key) {
        var value = queryParameters[key];
        parameters.push(key + '=' + encodeURIComponent(value || ''));
    });
    return url + '?' + parameters.join('&');
}
//# sourceMappingURL=lokiRequest.js.map

/***/ }),

/***/ 2727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLokiBootstrapperConfig_1 = __webpack_require__(2645);
var live_persona_card_bootstrapper_1 = __webpack_require__(2650);
var lokiConfig = undefined;
function fetchLokiConfigAsync() {
    if (lokiConfig) {
        return Promise.resolve(lokiConfig);
    }
    var bootstrapperConfig = getLokiBootstrapperConfig_1.getLokiBootstrapperConfig();
    return live_persona_card_bootstrapper_1.fetchLokiConfig(bootstrapperConfig).then(function (config) {
        lokiConfig = config;
        return lokiConfig;
    });
}
exports.fetchLokiConfigAsync = fetchLokiConfigAsync;
//# sourceMappingURL=fetchLokiConfigAsync.js.map

/***/ }),

/***/ 3205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['featurePeople', 'favoriteButtonLabel', 'emailButtonLabel', 'firstRunExperienceHeader', 'firstRunExperienceContent', 'firstRunExperienceButton'];
var stringModule = index_1.registerStringPackage('owa-people-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 5973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var datapoints_1 = __webpack_require__(5974);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var Check_1 = __webpack_require__(683);
var Persona_1 = __webpack_require__(234);
var owa_analytics_1 = __webpack_require__(12);
var owa_analytics_2 = __webpack_require__(12);
var owa_favorites_1 = __webpack_require__(1721);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var owa_mail_favorites_store_2 = __webpack_require__(32);
var MailListFilter_1 = __webpack_require__(2322);
var owa_mail_list_selection_orchestrator_1 = __webpack_require__(81);
var getSelectedTableView_1 = __webpack_require__(46);
var owa_mail_message_actions_1 = __webpack_require__(689);
var owa_people_persona_header_first_run_view_1 = __webpack_require__(5975);
var PersonaControl_1 = __webpack_require__(673);
var store_1 = __webpack_require__(2620);
var getUserConfiguration_1 = __webpack_require__(9);
var ReadingPanePosition_1 = __webpack_require__(52);
var owa_people_strings_1 = __webpack_require__(3205);
var React = __webpack_require__(3);
var PersonaCardBehavior_1 = __webpack_require__(2655);
var favoritesBitFlagsActions_1 = __webpack_require__(700);
var viewFiltersForMailFolderNode = ['All', 'Unread', 'ToOrCcMe', 'Flagged'];
var styles = __webpack_require__(5982);
var classNames = __webpack_require__(30).bind(styles);
var PersonaHeader = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaHeader, _super);
    function PersonaHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCheckAll = function (tableView) {
            // PersonaHeader could be loaded independent of list view in PhotoHub,
            // so we need to check if tableView is null
            var isInCheckedMode = tableView && tableView.isInCheckedMode;
            var isListViewEmpty = tableView && tableView.rowKeys.length == 0;
            var isReadingPanePositionOff = getUserConfiguration_1.default().UserOptions.GlobalReadingPanePositionReact ==
                ReadingPanePosition_1.default.Off;
            var checkBoxClassNames = classNames(isReadingPanePositionOff ? styles.checkBoxSingleLine : styles.checkBoxThreeColumn, isInCheckedMode && styles.showCheckbox, !isListViewEmpty && styles.listViewHasItems);
            return (React.createElement("div", { className: checkBoxClassNames, onClick: isListViewEmpty ? null : function () { return owa_mail_list_selection_orchestrator_1.MailListSelection.toggleCheckAll(tableView); } }, React.createElement(Check_1.Check, { checked: isInCheckedMode })));
        };
        _this.handleEmailClick = function (ev) {
            owa_analytics_1.logUsage(owa_mail_message_actions_1.datapoints.MailComposeFromHeader.datapoint.name);
            if (_this.props.composeEmailClick) {
                _this.props.composeEmailClick();
            }
            else {
                owa_mail_message_actions_1.lazyNewMessage.importAndExecute('PersonaHeader', null /*groupId*/, _this.props.personEmail, _this.props.personName, true);
            }
        };
        _this.toggleFavoriteState = function (evt) {
            evt.stopPropagation();
            _this.toggleFavoritePersona();
        };
        return _this;
    }
    PersonaHeader.prototype.render = function () {
        var personEmail = this.props.personEmail;
        var titleText = this.props.personNameDisplayOverride || this.props.personName;
        var isPersonFavorite = owa_mail_favorites_store_2.isPersonaInFavorites(this.props.personId, personEmail);
        var tableView = getSelectedTableView_1.default();
        return (React.createElement("div", { className: styles.headerContainer },
            React.createElement("div", { className: styles.imageAndInfoContainer },
                this.getImageControl(),
                this.getPersonInfo(titleText)),
            this.getHeaderButtons(tableView, isPersonFavorite),
            this.showPersonaHeaderFirstRunExperience()));
    };
    PersonaHeader.prototype.componentDidMount = function () {
        this.logHeaderRendered();
    };
    PersonaHeader.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.personId !== prevProps.personId ||
            this.props.favoriteActionSource !== prevProps.favoriteActionSource) {
            this.logHeaderRendered();
        }
    };
    PersonaHeader.prototype.shouldShowPersonaHeaderFirstRun = function () {
        if (!store_1.default.recipientCache) {
            return false;
        }
        // Show the persona header first run experience only once
        if (favoritesBitFlagsActions_1.getIsBitEnabled(4 /* PersonaHeaderFirstRunSeen */)) {
            return false;
        }
        // If the header was displayed from the search
        if (this.props.favoriteActionSource !== 'PersonaHeaderFromFolderSearch' &&
            this.props.favoriteActionSource !== 'PersonaHeaderFromPersonaSearch') {
            return false;
        }
        // If the user doesn't have any persona favorites
        if (owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes.size > 0) {
            return false;
        }
        if (!this.props.personEmail) {
            return false;
        }
        var personEmailLowerCase = this.props.personEmail.toLowerCase();
        // If the displayed persona is within the top 100 people returned from findPeople (rcStore.recipientCache is sorted)
        return store_1.default.recipientCache
            .slice(0, 100)
            .some(function (persona) {
            return persona.EmailAddresses.some(function (emailAddress) {
                return (emailAddress.OriginalDisplayName &&
                    emailAddress.OriginalDisplayName.toLowerCase() ===
                        personEmailLowerCase) ||
                    (emailAddress.EmailAddress &&
                        emailAddress.EmailAddress.toLowerCase() === personEmailLowerCase);
            });
        });
    };
    PersonaHeader.prototype.getImageControl = function () {
        return (React.createElement("div", null,
            React.createElement(LPCWrapper, { emailAddress: this.props.personEmail, name: this.props.personName, composeEmailOverride: this.props.composeEmailClick, personaType: 'User' },
                React.createElement(PersonaControl_1.default, { emailAddress: this.props.personEmail, name: this.props.personName, size: Persona_1.PersonaSize.regular }))));
    };
    PersonaHeader.prototype.getPersonInfo = function (titleText) {
        return (React.createElement("div", { className: styles.personInfoContainer },
            React.createElement(LPCWrapper, { emailAddress: this.props.personEmail, name: this.props.personName, composeEmailOverride: this.props.composeEmailClick, personaType: 'User' },
                React.createElement("div", { className: styles.personName }, titleText),
                React.createElement("div", { className: styles.personEmail }, this.props.personEmail))));
    };
    PersonaHeader.prototype.showPersonaHeaderFirstRunExperience = function () {
        if (this.toggleFavoriteDiv && this.shouldShowPersonaHeaderFirstRun()) {
            return React.createElement(owa_people_persona_header_first_run_view_1.PersonaHeaderFirstRun, { target: this.toggleFavoriteDiv });
        }
        return null;
    };
    PersonaHeader.prototype.getHeaderButtons = function (tableView, isPersonaFavorite) {
        var _this = this;
        var controlsContainerClassNames = classNames(styles.controlsContainer, this.props.hideCheckAll && styles.noCheckbox);
        var buttonWrapperClassName = this.props.hideCheckAll
            ? styles.wideButtonsWrapper
            : styles.buttonsWrapper;
        var buttonStyles = {
            root: styles.button,
        };
        return (React.createElement("div", { className: controlsContainerClassNames },
            !this.props.hideCheckAll && this.renderCheckAll(tableView),
            React.createElement("div", { className: buttonWrapperClassName },
                React.createElement(Button_1.ActionButton, { iconProps: {
                        iconName: "Mail" /* Mail */,
                        styles: {
                            root: styles.mailIcon,
                        },
                    }, styles: buttonStyles, text: owa_people_strings_1.default.emailButtonLabel, onClick: this.handleEmailClick }),
                React.createElement("div", { ref: function (ref) { return (_this.toggleFavoriteDiv = ref); } },
                    React.createElement(owa_favorites_1.ToggleFavoriteButton, { isWrappedInAnotherButton: true, isInFavorites: isPersonaFavorite, className: styles.favoriteButtonWrapper, onClick: this.toggleFavoriteState, animate: true, text: owa_people_strings_1.default.favoriteButtonLabel, styles: buttonStyles, isClickDisabled: !owa_mail_favorites_store_1.favoritesStore.isFavoritePersonasChangeable }))),
            this.props.hideFilter ? null : (React.createElement("div", { className: styles.filterWrapper },
                React.createElement(MailListFilter_1.default, { supportedViewFilters: viewFiltersForMailFolderNode, containerClassName: styles.mailFilterContainer, filterMenuSource: 'PeopleFilterMenu', tableViewId: tableView.id })))));
    };
    PersonaHeader.prototype.toggleFavoritePersona = function (isRetry) {
        var _this = this;
        owa_mail_favorites_store_2.lazyToggleFavoritePersona
            .importAndExecute(this.props.personId, this.props.personEmail, this.props.personName, isRetry ? 'NotificationActionClick' : this.props.favoriteActionSource)
            .catch(function (e) {
            return owa_mail_favorites_store_2.lazyHandleToggleFavoritePersonaError.importAndExecute(e, function () {
                return _this.toggleFavoritePersona(true);
            });
        });
    };
    PersonaHeader.prototype.logHeaderRendered = function () {
        var eventName = datapoints_1.default.PersonaHeaderShown.datapoint.name;
        owa_analytics_1.logUsage(eventName, [this.props.favoriteActionSource]);
    };
    PersonaHeader = tslib_1.__decorate([
        owa_analytics_2.logMountingPerformance('PersonaHeader'),
        mobx_react_1.observer
    ], PersonaHeader);
    return PersonaHeader;
}(React.Component));
exports.default = PersonaHeader;
var LPCWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(LPCWrapper, _super);
    function LPCWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPCWrapper.prototype.render = function () {
        return (React.createElement("div", { onClick: this.props.onPersonaCardBehaviorClick, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave }, this.props.children));
    };
    LPCWrapper = tslib_1.__decorate([
        PersonaCardBehavior_1.personaCardBehavior
    ], LPCWrapper);
    return LPCWrapper;
}(React.Component));
//# sourceMappingURL=PersonaHeader.js.map

/***/ }),

/***/ 5974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PersonaHeaderShown: { datapoint: { name: 'PersonaHeaderShown' } },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 5975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('PersonaHeaderFirstRun');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 5976));
});
exports.PersonaHeaderFirstRun = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.PersonaHeaderFirstRun; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5982:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5983);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5983:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3AFtNNUUqyc5fp7Y0vYaQm{white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;position:relative}html[dir] ._3AFtNNUUqyc5fp7Y0vYaQm{border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\";padding:20px 0 0}._1BqkSjWUUiYIcUce9UwSHl{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden}html[dir=ltr] ._1BqkSjWUUiYIcUce9UwSHl{margin-left:12px}html[dir=rtl] ._1BqkSjWUUiYIcUce9UwSHl{margin-right:12px}._2hNKGj_Yz8YeT-bLt0pNwK{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._2hNKGj_Yz8YeT-bLt0pNwK{margin-bottom:12px}html[dir=ltr] ._2hNKGj_Yz8YeT-bLt0pNwK{padding-left:20px}html[dir=rtl] ._2hNKGj_Yz8YeT-bLt0pNwK{padding-right:20px}.Jd1dRCqHPXMw19gGtxlmg{font-size:21px;font-weight:300;overflow:hidden;text-overflow:ellipsis}html[dir] .Jd1dRCqHPXMw19gGtxlmg{margin-bottom:3px}.QMRmMgdoVcrSZgKrSBel6{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\";overflow:hidden;text-overflow:ellipsis}._2iV4p4f98H_Tu58xgMPVS1{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}html[dir] ._2iV4p4f98H_Tu58xgMPVS1{padding-bottom:12px}html[dir=ltr] ._2iV4p4f98H_Tu58xgMPVS1._18EsAJCWnpeAvfTWwCriVC{padding-left:20px}html[dir=rtl] ._2iV4p4f98H_Tu58xgMPVS1._18EsAJCWnpeAvfTWwCriVC{padding-right:20px}._1N0FykMJjY4T8qTDm5ySeQ{display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden;font-size:14px}html[dir=ltr] ._2TnPkZKmo-m6ug-_XylddA{padding-left:60px}html[dir=rtl] ._2TnPkZKmo-m6ug-_XylddA{padding-right:60px}.Acqq_FKTdCWBxUcBxIQWo{color:\"[theme:themePrimary, default:#0078D7]\"}.Acqq_FKTdCWBxUcBxIQWo:hover{color:\"[theme:themeDarker, default:#004578]\"}.Acqq_FKTdCWBxUcBxIQWo:active{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] .x0si7fBCXJUV3xI_El13p,html[dir=rtl] .x0si7fBCXJUV3xI_El13p{margin-left:0;margin-right:0}._3ZUUBrVch1seiLMe3-xaDO{height:28px}html[dir] ._3ZUUBrVch1seiLMe3-xaDO{padding:0}.TqWOMaCV-OS2bhwMQ9xqZ{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}html[dir=ltr] .TqWOMaCV-OS2bhwMQ9xqZ{padding-left:4px;margin-left:0;margin-right:0}html[dir=rtl] .TqWOMaCV-OS2bhwMQ9xqZ{padding-right:4px;margin-right:0;margin-left:0}html[dir=ltr] ._2HyZBpSzGepdTGJ5IAwJKp{margin-left:6px}html[dir=rtl] ._2HyZBpSzGepdTGJ5IAwJKp{margin-right:6px}html[dir=ltr] .cGnacnEnb2aiVFdBl1Upc{margin-left:5px}html[dir=rtl] .cGnacnEnb2aiVFdBl1Upc{margin-right:5px}._3LlKhem4i9ngK-Q5kegJGT{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:relative;top:-2px}html[dir] ._1w264mXGEU_fIeKr4og8-N{margin:0}html[dir=ltr] ._1w264mXGEU_fIeKr4og8-N{padding-right:10px}html[dir=rtl] ._1w264mXGEU_fIeKr4og8-N{padding-left:10px}._1kfPJZJ1ayfv6RrqfL3L8h{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._1NsPQkLinPuhS5KJNiFGdm,._1TpR9ZSqpSflsx2Etc0XGT,._3XjI05ELUYt5OoGWL5SHjm{cursor:pointer;visibility:hidden;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:28px;height:28px}html[dir=ltr] ._1NsPQkLinPuhS5KJNiFGdm,html[dir=ltr] ._1TpR9ZSqpSflsx2Etc0XGT,html[dir=ltr] ._3XjI05ELUYt5OoGWL5SHjm{margin-left:20px}html[dir=rtl] ._1NsPQkLinPuhS5KJNiFGdm,html[dir=rtl] ._1TpR9ZSqpSflsx2Etc0XGT,html[dir=rtl] ._3XjI05ELUYt5OoGWL5SHjm{margin-right:20px}._1TpR9ZSqpSflsx2Etc0XGT._3IEW3AoM7iQ22GKs0zmW4p.FU9oHt2JM5Ou5neXxSI8Q,._3AFtNNUUqyc5fp7Y0vYaQm:hover ._1TpR9ZSqpSflsx2Etc0XGT.FU9oHt2JM5Ou5neXxSI8Q,._3AFtNNUUqyc5fp7Y0vYaQm:hover .FU9oHt2JM5Ou5neXxSI8Q._1NsPQkLinPuhS5KJNiFGdm,._3AFtNNUUqyc5fp7Y0vYaQm:hover .FU9oHt2JM5Ou5neXxSI8Q._3XjI05ELUYt5OoGWL5SHjm,._3IEW3AoM7iQ22GKs0zmW4p.FU9oHt2JM5Ou5neXxSI8Q._1NsPQkLinPuhS5KJNiFGdm,._3IEW3AoM7iQ22GKs0zmW4p.FU9oHt2JM5Ou5neXxSI8Q._3XjI05ELUYt5OoGWL5SHjm{visibility:visible}html[dir=ltr] ._3XjI05ELUYt5OoGWL5SHjm{margin-left:32px;margin-right:20px}html[dir=rtl] ._3XjI05ELUYt5OoGWL5SHjm{margin-right:32px;margin-left:20px}html[dir=ltr] ._1NsPQkLinPuhS5KJNiFGdm{margin-left:12px;margin-right:40px}html[dir=rtl] ._1NsPQkLinPuhS5KJNiFGdm{margin-right:12px;margin-left:40px}", ""]);

// exports
exports.locals = {
	"headerContainer": "_3AFtNNUUqyc5fp7Y0vYaQm",
	"personInfoContainer": "_1BqkSjWUUiYIcUce9UwSHl",
	"imageAndInfoContainer": "_2hNKGj_Yz8YeT-bLt0pNwK",
	"personName": "Jd1dRCqHPXMw19gGtxlmg",
	"personEmail": "QMRmMgdoVcrSZgKrSBel6",
	"controlsContainer": "_2iV4p4f98H_Tu58xgMPVS1",
	"noCheckbox": "_18EsAJCWnpeAvfTWwCriVC",
	"buttonsWrapperBase": "_1N0FykMJjY4T8qTDm5ySeQ",
	"buttonsWrapper": "go37vbKppn9tsHulLv3A_ _1N0FykMJjY4T8qTDm5ySeQ",
	"wideButtonsWrapper": "_2TnPkZKmo-m6ug-_XylddA _1N0FykMJjY4T8qTDm5ySeQ",
	"iconBase": "Acqq_FKTdCWBxUcBxIQWo",
	"mailIcon": "x0si7fBCXJUV3xI_El13p Acqq_FKTdCWBxUcBxIQWo",
	"button": "_3ZUUBrVch1seiLMe3-xaDO",
	"emailButtonWrapper": "_7OlTNy16NWU67A9kxAvFG _3ZUUBrVch1seiLMe3-xaDO",
	"favoriteButtonWrapper": "TqWOMaCV-OS2bhwMQ9xqZ",
	"emailIconLabel": "_2HyZBpSzGepdTGJ5IAwJKp",
	"favoriteIconLabel": "cGnacnEnb2aiVFdBl1Upc",
	"favoriteIconWrapper": "_3LlKhem4i9ngK-Q5kegJGT",
	"mailFilterContainer": "_1w264mXGEU_fIeKr4og8-N",
	"filterWrapper": "_1kfPJZJ1ayfv6RrqfL3L8h",
	"checkBox": "_1TpR9ZSqpSflsx2Etc0XGT",
	"checkBoxSingleLine": "_3XjI05ELUYt5OoGWL5SHjm",
	"checkBoxThreeColumn": "_1NsPQkLinPuhS5KJNiFGdm",
	"showCheckbox": "_3IEW3AoM7iQ22GKs0zmW4p",
	"listViewHasItems": "FU9oHt2JM5Ou5neXxSI8Q"
};

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var datapoints_1 = __webpack_require__(1709);
exports.datapoints = datapoints_1.default;
owa_bundling_1.preloadScriptChunk('MailMessageActions');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 2251));
});
exports.lazyNewMessage = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.newMessage; });
exports.lazyReplyToConversation = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.replyToConversation; });
exports.lazyForwardConversation = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.forwardConversation; });
exports.lazyPrintConversation = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.printConversation; });
exports.lazyReplyToItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.replyToItem; });
exports.lazyForwardItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.forwardItem; });
exports.lazyPrintItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.printItem; });
exports.lazyShowConversationInImmersiveReader = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.showConversationInImmersiveReader; });
//# sourceMappingURL=index.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.PeopleExperiences.js